import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  Flex,
  FormLabel,
  Heading,
  Input,
  ListItem,
  Radio,
  RadioGroup,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
  UnorderedList,
  useColorModeValue,
} from "@chakra-ui/react";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningIcon from "@mui/icons-material/Warning";
import NotFound from "assets/svg/not-found.svg";
import Searchicon from "assets/svg/search-icon.svg";
import axios from "axios";
import CommonSubmissionFile from "components/CommonSubmissionFile/CommonSubmissionFile";
import JobDescriptionEditor from "components/Commoncomponent/JobDescriptionEditor/JobDescriptionEditor";
import NoteSubmissionModel from "components/Commoncomponent/Note/NoteSubmissionModel";
import CustomizeColumns from "components/CustomizeColumns/CustomizeColumns";
import EditCandidateModal from "components/EditCandidateModal/EditCandidateModal";
import EditSubmissionStatusModel from "components/EditSubmissionStatusModel/EditSubmissionStatusModel";
import SearchCandidateModel from "components/SearchCandidateModel/SearchCandidateModel";
import { City, Country, State } from "country-state-city";
import * as FileSaver from "file-saver";
import { useFormik } from "formik";
import { MDBContainer } from "mdb-react-ui-kit";
import moment from "moment";
import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ListGroup from "react-bootstrap/ListGroup";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useCookies } from "react-cookie";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useParams } from "react-router";
import { Link, useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { getOptionById, handleCandidateShortSummarySubmit, handleSaveNoteShortSummaryEdit, userActivity } from "../../Utils";
import config from "../../config";
import {
  defaultSubmHeaderOrders,
  submCandidateHeaderShow,
} from "../../constant";
import ComposeMailForm from "./ComposeMailForm";
import Loader from "./Loader";
import ParsedResumeDetails from "./ParsedResumeDetails";
import Submissionform from "./Submissionform";
import "./org.css";
import { SelectPicker } from "rsuite";
import { useSelector } from "react-redux";
import MatchedCandidatesTable from '../../components/matcheCandidate/MatchedCandidate'
import FileViewer from "react-file-viewer";
import DeleteModal from "../../components/Commoncomponent/DeleteModal";

import ResumePreviewModal from "../../components/Commoncomponent/ResumePreviewModal";
import JobAddModal from "../../components/Commoncomponent/JobAddModal";
//Schema For Formik validation
const addJobs = Yup.object().shape({
  jobtitle: Yup.string().required("Please Enter Job title"),
  country: Yup.string().required("Please Select Country"),
  targetdate: Yup.string().required("Please Select Target Date"),
  status: Yup.string().required("Please Select Status"),
  jobtype: Yup.string().required("Please Select Job Type"),
  city: Yup.string().required("Please Select City"),
  state: Yup.string().required("Please Select State"),
  remotestatus: Yup.string().required("Please Select Remort Status"),
  jobdescription: Yup.string().required("Please Add Job Description"),
  experience: Yup.string().required("Please Select Experience"),
  clientId: Yup.string(),
  clients: Yup.string().required("Please Select Client"),
  numberofPosition: Yup.number().required(
    "Please Add Number Of Poistion For Job"
  ),
  skill: Yup.string().required("Please Add Required Skill For Job"),
  question: Yup.string(),
  placementType: Yup.string().required("Please Select Placement Type"),
  clientpayType: Yup.string().required("Please Select Clinent Pay Type"),
  ctc: Yup.string().required("Please Add CTC"),
  onetimeplacementbillType: Yup.string(),
  onetimeplacementbillValue: Yup.number(),
  team: Yup.string(),
  teamleader: Yup.string(),
  recruiter: Yup.string(),
  customertype: Yup.string(),
  email: Yup.string(),
  industry: Yup.string().required("Please select industry"),
  ownerPhone: Yup.string().required("Please add phone number"),
  jobAddress: Yup.string(),
  pincode: Yup.number(),
});

//Formik Schema For Add Candidate
const addCandidate = Yup.object().shape({
  firstName: Yup.string().required("Enter first name"),
  lastName: Yup.string().required("Enter last name"),
  email: Yup.string().email().required("Enter email address"),
  phone: Yup.string()
    .required("Please enter mobile number")
    .min(13, "Enter valid mobile number")
    .max(13, "Enter valid mobile number"),
  password: Yup.string(),
  status: Yup.string().required("Please select status"),
  skill: Yup.string().required("Please add required skill for job"),
  experiance: Yup.string().required("Please select experience"),
  designation: Yup.string().required("Please select designation"),
  PancardNumber: Yup.string(),
  AadharcardNumber: Yup.string(),
  dateofBirth: Yup.string(),
  gender: Yup.string().required("Please select gender"),
  country: Yup.string().required("Please select country"),
  state: Yup.string().required("Please select state"),
  city: Yup.string().required("Please select city"),
  address: Yup.string(),
  pincode: Yup.string(),
  source: Yup.string().required("Please select source"),
  currentCandidateCTCType: Yup.string(),
  currentCandidateCTC: Yup.string(),
  expectedCandidateCTCType: Yup.string(),
  expectedCandidateCTC: Yup.string(),
  noticePeriod: Yup.string().required("Please add notice period"),
  stateCode: Yup.string().notRequired(),
  countryCode: Yup.string().notRequired(),
  candidateStatus: Yup.string(),
  industry: Yup.string().required("Please select industry"),
  file: Yup.mixed()
    .required("File Is Required")
    .test("file", "Unsupported file type", (value) => {
      if (!value) return true;
      return (
        value &&
        (value.type === "application/pdf" ||
          value.type === "image/jpeg" ||
          value.type === "image/png" ||
          value.type === "application/msword" ||
          value.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
      );
    })
    .test("fileSize", "File size is too large", (value) => {
      if (!value) return true;
      return value && value.size <= 5024000;
    }),
});

//Formik Schema For edit Candidate
const editCandidate = Yup.object().shape({
  firstName: Yup.string().required("Enter first name"),
  lastName: Yup.string().required("Enter last name"),
  email: Yup.string().email().required("Enter email address"),
  phone: Yup.string().required("Please enter mobile number"),
  password: Yup.string(),
  status: Yup.string().required("Please select status"),
  skill: Yup.string().required("Please add required skill for job"),
  experiance: Yup.string().required("Please select experience"),
  designation: Yup.string().required("Please select designation"),
  PancardNumber: Yup.string(),
  AadharcardNumber: Yup.string(),
  dateofBirth: Yup.string(),
  gender: Yup.string().required("Please select gender"),
  country: Yup.string().required("Please select country"),
  state: Yup.string().required("Please select state"),
  city: Yup.string().required("Please select city"),
  address: Yup.string(),
  pincode: Yup.string(),
  source: Yup.string().required("Please select source"),
  noticePeriod: Yup.string().required("Please add notice period"),
  candidateStatus: Yup.string(),
  file: Yup.mixed().required("File is required"),
  industry: Yup.string().required("Please select industry"),
});

function Jobpostview() {
  const history = useHistory();
  const { userNames } = useSelector((state) => state.usersSlice);
  const { userNames: reduxUserNames } = useSelector(
    (state) => state.usersSlice
  );
  const [searchSourceData, setSearchSourceData] = useState([]);
  const [isFilterActiveSourceSearch, setIsFilterActiveSourceSearch] =
    useState(false);
  const handleGoBack = () => {
    history?.goBack();
  };
  const [cookie] = useCookies(["role", "id", "token"]);
  const candidate_ownerName = localStorage?.getItem("candidate_ownerName");
  const userId = cookie.id;
  const userRole = cookie?.role;
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [teamData, setTeamData] = useState([]);
  const [changes, setChanges] = useState({});
  const location = useLocation();
  const routers = location.pathname;
  const parts = routers.split("/");
  const router = parts.slice(1, -1).join("/");
  const queryParams = new URLSearchParams(location?.search);
  const iParam = queryParams?.get("i");
  const [searchSubmissionId, setSearchSubmissionId] = useState([]);
  const [isFilterActiveSubmissionId, setIsFilterActiveSubmissionId] = useState(false)
  const [loading, setLoading] = useState(true);
  const [submissionLoading, setSubmissionLoading] = useState(true);
  const [jobpost, setJobpost] = useState({});
  const [jobBranch, setJobBranch] = useState({});
  const [searchBranch, setSearchBranch] = useState([]);
  const [isFilterActiveBranch, setIsFilterActiveBranch] = useState(false);

  const [displayjobpost, setDisplayJobpost] = useState([]);
  const [applicationStatus, setApplicationStatus] = useState([]);
  const [candidateStatus, setCandidateStatus] = useState([]);
  const [appliedJob, setAppliedJob] = useState([]);
  const [displayAppliedJob, setDisplayAppliedJob] = useState([]);
  const [submissionid, setSubmissionId] = useState("");
  const [editSubmission, SetEditSubmission] = useState(false);
  const [removeSubmission, SetRemoveSubmission] = useState(false);
  const [moduleData, setModuleData] = useState({});
  const [candidateModuleData, setCandidateModuleData] = useState(null);
  const [submissionModuleData, setSubmissionModuleData] = useState({});
  const [interviewscheduleModuleData, setInterviewscheduleModuleData] =
    useState({});
  const [uniqueCandidateId, setUniqueCandidateId] = useState("")
  const [pipelinedCandidates, setPipelinedCandidates] = useState([]);
  const [interviewedCandidates, setInterviewedCandidates] = useState([]);
  const [displayinterviewedCandidates, setDisplayInterviewedCandidates] =
    useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [acceptedCandidates, setAcceptedCandidates] = useState([]);
  const [onboardedCandidates, setOnboardedCandidates] = useState([]);
  const [onboardingprogressCandidates, setOnboardingprogressCandidates] =
    useState([]);
  const [activity, SetActivity] = useState([]);

  const [searchAllSubmissionfields, setSearchAllSubmissionfields] =
    useState("");
  const [parseSummary, setParseSummary] = useState("");
  // const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  // const [selectedAccountManager, setSelectedAccountManager] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedTeamLeader, setSelectedTeamLeader] = useState(null);
  const [selectedTeamD, setSelectedTeamD] = useState([])
  const [jdLoading, setJdLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [jobLoading, setJobLoading] = useState(false);
  const [alluserTeams, setAlluserTeams] = useState([])
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const [selectedAccountManager, setSelectedAccountManager] = useState(null);

  const [selectedClientContactName, setSelectedClientContactName] =
    useState(null);
  const [searchCandidateOwnerName, setSearchCandidateOwnerName] =
    useState(null);
  const getCurrentLoggedInUserName = getOptionById(userId, userNames);
  const [submission, setSubmission] = useState({
    jobId: "",
    clientId: "",
    candidateId: "",
    Questions: "",
    email: "",
    skill: "",
    clientemail: "",
    status: "Internal-Submitted",
    currentCandidateCTCType: "",
    currentCandidateCTC: "",
    expectedCandidateCTCType: "",
    expectedCandidateCTC: "",
    noticePeriod: "",
    relevantExperiance: "",
    availability: "",
    engagement: "",
    locationPreference: "",
    QnA: [],
    file: "",
    fileName: "",
    filePath: "",
    submitterName: "",
  });
  const [searchcandidate, setSearchcandidate] = useState("");
  const [searchCandidateModelShow, setSearchCandidateModelShow] =
    useState(false);
  const [submitSubmission, SetSubmitSubmission] = useState(false);
  const [matchingSkills, setMatchingSkills] = useState([]);
  const [missingSkills, setMissingSkills] = useState([]);
  const [parsedSkills, setParsedSkills] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [candidatesubmissionpage, setCandidateSubmissionPage] = useState(0);
  const [rowsPerCandidateSubmissionPage, setRowsPerCandidateSubmissionPage] =
    useState(10);
  const [parsedObjectives, setParsedObjectives] = useState("");

  const [searchQuery, setSearchQuery] = useState(false);
  const [linkedinUrl, setLinkedinUrl] = useState("");

  const [ViewCandidate, SetCandidateShow] = useState(false);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState("");
  const [filePath, setFilePath] = useState("");
  const [parsedata, setParsedata] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState({
    name: "India",
    isoCode: "IN",
  });
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [ViewparseModel, setViewparseModel] = useState(false);
  const [resumeDuplicateModel, setResumeDuplicateModel] = useState(false);
  const [findCandidate, setFindCandidate] = useState([]);
  const [radiovalue, setRadioValue] = useState("");
  const [candiId, setCandiId] = useState("");
  const [candidatename, Setcandidatename] = useState([]);
  const [ViewEdit, SetEditShow] = useState(false);
  const [jobtitle, Setjobtitle] = useState([]);
  const [jobId, setJobId] = useState("");
  const [ViewEditJob, SetEditJobShow] = useState(false);
  const [accountmanagers, setAccountmanagers] = useState([]);
  const [teamleaders, setTeamleaders] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [clients, setClients] = useState([]);
  const [clientname, SetClientname] = useState("");
  const [editjobpost, setEditJobpost] = useState({
    jobtitle: "",
    country: "India",
    targetdate: "",
    recruiter: "",
    teamleader: "",
    status: "",
    jobtype: "",
    city: "",
    state: "",
    remotestatus: "",
    accountmanager: "",
    jobdescription: "",
    experience: "",
    clientId: "",
    clientContactName: "",
    accountName: "",
    email: "",
    numberofPosition: "",
    skill: "",
    question: "",
    placementType: "",
    clientpayType: "",
    ctc: "",
    onetimeplacementbillType: "",
    onetimeplacementbillValue: "",
  });
  const [searchParams, setSearchParams] = useState({
    name: "",
    minScore: 0,
    maxScore: 100,
    sortField: null,
    sortDirection: "asc"
  });
  const [loadingResumeScreening, setLoadingResumeScreening] = useState(false);
  const [parseResumeConclusion, setparseResumeConclusion] = useState("");
  const [parsePercentage, setParsePercentage] = useState("");
  const [parseAge, setParseAge] = useState("");
  const [ViewSendMail, SetSendMailShow] = useState(false);
  const [checked, SetIschecked] = useState([]);
  const [toemail, SetToemail] = useState("");
  const [ccemail, SetCcemail] = useState("");
  const [bccemail, SetBccemail] = useState("");
  const [subject, SetSubject] = useState("");
  const [mailMessage, SetMailMessage] = useState("");
  const [submissionPreview, SetSubmissionPreview] = useState(false);
  const [objectURL, setObjectURL] = useState("");
  const [editSubmissionStatus, SetEditSubmissionStatus] = useState(false);
  const [sendMail, setSendMail] = useState(false);
  const [showResumeDetails, setShowResumeDetails] = useState(true);
  const [activityStatus, setActivityStatus] = useState("");
  const toggleResumeDetails = () => {
    setShowResumeDetails((prevShow) => !prevShow);
  };
  const [candidate, setCandidate] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    status: "",
    skill: "",
    experiance: "",
    designation: "",
    PancardNumber: "",
    AadharcardNumber: "",
    dateofBirth: "",
    gender: "",
    country: "",
    state: "",
    city: "",
    address: "",
    pincode: "",
    source: "",
    candidateStatus: "",
    educationDetails: [],
    workExperience: [],
    reference: [],
  });

  const [eductionFields, setEductionFields] = useState([
    {
      institutename: "",
      degree: "",
      startDate: "",
      endDate: "",
      percentage: "",
      category: "",
    },
  ]);
  const [matchedData, setMatchedData] = useState([]);
  const [matchedCandidateLoading, setMatchedCandidateLoading] = useState(true);
  const [matchedCandidateError, setMatchedCandidateError] = useState(null);
  const [matchedCandidatePagination, setMatchedCandidatePagination] = useState({
    totalDocuments: 0,
    currentPage: 0,
    totalPages: 0,
    limit: 10,
  });
  const getContactdata = async (id) => {
    try {
      const response = await axios.get(
        `${config?.apiUrl}/api/get_client_contact/${id}`,
        {
          headers: {
            Authorization: `Bearer ${cookie.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const contactsData = response.data.data;
      setContacts(contactsData);
      return contactsData;
    } catch (err) {
      toast.error(err?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const getAllUserTeams = async () => {
    await axios
      .get(`${config?.apiUrl}/api/get_All_userTeams`, {
        headers: {
          Authorization: `Bearer ${cookie.token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const statusdata = response.data.data;
        setAlluserTeams(statusdata);
        return statusdata
      })
      .catch((err) => {
        toast.error(err.response.data.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const [getnotes, setGetNotes] = useState([]);
  const [note, setNote] = useState({});
  const [searchNote, setSearchNote] = useState("");
  const [notesLoading, setNotesLoading] = useState(false);
  const [jobNote, setJobNote] = useState(false);
  const handleJobNoteShow = () => {
    setJobNote(true);
  };
  const handleJobNoteClose = () => {
    setJobNote(false);
  };
  const [oldJobId, setOldJobId] = useState("");
  const [candidateNote, setCandidateNote] = useState(false);
  const [ViewSubmheaderOrders, setViewSubmheaderOrders] = useState(false);

  const [submheaderOrders, setSubmHeaderOrders] = useState(
    JSON.parse(localStorage.getItem("submheaderOrders")) ||
    defaultSubmHeaderOrders.filter(
      (header) => submCandidateHeaderShow[header]
    )
  );
  const [displaySubmheaderOrders, setDisplaySubmheaderOrders] = useState(
    defaultSubmHeaderOrders
  );
  const [defaultDisplaySubmHeaderOrders, setDefaultDisplaySubmHeaderOrders] =
    useState(
      JSON.parse(localStorage.getItem("defaultDisplaySubmHeaderOrders")) ||
      submCandidateHeaderShow
    );
  const handleSubmHeaderOrdersshow = () => {
    setViewSubmheaderOrders(true);
  };
  const handleSubmHeaderOrdersClose = () => {
    setViewSubmheaderOrders(false);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(displaySubmheaderOrders);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDisplaySubmheaderOrders(items);
  };

  const handleApplyClick = () => {
    const temp = Object.keys(defaultDisplaySubmHeaderOrders).filter(
      (key) => defaultDisplaySubmHeaderOrders[key]
    );
    const main = displaySubmheaderOrders.filter((key) => temp.includes(key));
    setSubmHeaderOrders(main);
    toast.success("Columns change successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    handleSubmHeaderOrdersClose();
  };
  const handleCheckboxChange = (key, isChecked) => {
    const temp = JSON.parse(JSON.stringify(defaultDisplaySubmHeaderOrders));
    temp[key] = isChecked;
    setDefaultDisplaySubmHeaderOrders(temp);
  };

  const handleCandidateNoteShow = () => {
    setCandidateNote(true);
  };
  const handleCandidateNoteClose = () => {
    setCandidateNote(false);
  };


  const handleChangePageMatchedCandidate = (event, newPage) => {
    setMatchedCandidatePagination({
      ...matchedCandidatePagination,
      currentPage: newPage,
    });
  };

  const handleChangeRowsPerPageMatchedCandidate = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setMatchedCandidatePagination({
      ...matchedCandidatePagination,
      currentPage: 0,
      limit: newRowsPerPage,
    });
  };
  // const getCandidatNotes = (id) => {
  //   axios
  //     .get(`${config?.apiUrl}/api/get_Candidate_Note/${id}`)
  //     .then((response) => {
  //       const notedata = response.data.data;
  //       setGetNotes(notedata);
  //     })
  //     .catch((err) => {
  //       toast.error(
  //         "Something happened wrong, please try again after sometime.",
  //         {
  //           position: toast.POSITION.TOP_RIGHT,
  //         }
  //       );
  //     });
  // };
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const filename = "Submissions";

  const exportSubmissions = (submissions, filename) => {
    // Check if any submission is selected
    if (checked.length === 0) {
      toast.error("Please select at least one user to export information", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    // Define file properties
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    // Filter submissions based on checked IDs
    const filteredSubmissions = submissions
      .filter((candidate) =>
        checked.some((check) => check.id === candidate._id)
      )
      .map((candidate) => {
        const filteredVal = {};

        displaySubmheaderOrders.forEach((field) => {
          const value = defaultDisplaySubmHeaderOrders[field];
          if (value) {
            switch (field) {
              case "email":
                filteredVal["Email"] = candidate.candidateId?.email;
                break;
              case "clientemail":
                filteredVal["Client Email"] = candidate.clientId?.email;
                break;
              case "firstName":
                filteredVal["First Name"] = candidate.candidateId?.firstName;
                break;
              case "lastName":
                filteredVal["Last Name"] = candidate.candidateId?.lastName;
                break;
              case "client":
                filteredVal["Client"] = candidate.clientId?.accountName;
                break;
              case "owner_name":
                filteredVal["Owner Name"] = candidate?.candidate_ownerName;
                break;
              case "city":
                filteredVal["City"] = candidate.candidateId?.city;
                break;
              case "state":
                filteredVal["State"] = candidate.candidateId?.state;
                break;
              case "phone":
                filteredVal["Phone"] = candidate.candidateId?.phone;
                break;
              case "DOB":
                filteredVal["Date of Birth"] =
                  candidate.candidateId?.dateofBirth;
                break;
              case "address":
                filteredVal["Address"] = candidate.candidateId?.address;
                break;
              case "aadharcardnumber":
                filteredVal["Aadhar Number"] =
                  candidate.candidateId?.AadharcardNumber;
                break;
              case "pancardnumber":
                filteredVal["PAN Number"] =
                  candidate.candidateId?.PancardNumber;
                break;
              case "designation":
                filteredVal["Designation"] = candidate.candidateId?.designation;
                break;
              case "jobtitle":
                filteredVal["Job Title"] = candidate.jobId?.jobtitle;
                break;
              case "workExperience":
                filteredVal["Comapny name"] =
                  candidate.candidateId &&
                  (candidate.candidateId.workExperience.length === 0
                    ? "N/A"
                    : candidate.candidateId.workExperience
                      .map((exp) => ({
                        ...exp,
                        startDate: exp.startDate
                          ? new Date(exp.startDate)
                          : null,
                        endDate: exp.endDate
                          ? exp.endDate.toLowerCase() === "present"
                            ? new Date()
                            : new Date(exp.endDate)
                          : exp.startDate,
                      }))
                      .sort((a, b) => (b.endDate || 0) - (a.endDate || 0))
                      .slice(0, 1)
                      .map((latestExperience, index) => {
                        return latestExperience?.companyname;
                      })[0]);
                break;
              case "educationDetails":
                filteredVal["Education"] =
                  candidate.candidateId &&
                  (candidate?.candidateId?.educationDetails.length === 0
                    ? "N/A"
                    : candidate.candidateId?.educationDetails
                      .map((edu) => ({
                        ...edu,
                        startDate: edu.startDate
                          ? new Date(
                            edu.startDate.replace(
                              /(\d{2})\/(\d{2})\/(\d{4})/,
                              "$2/$1/$3"
                            )
                          )
                          : null,
                        endDate: edu.endDate
                          ? new Date(
                            edu.endDate.replace(
                              /(\d{2})\/(\d{2})\/(\d{4})/,
                              "$2/$1/$3"
                            )
                          )
                          : null,
                      }))
                      .sort(
                        (a, b) =>
                          (b.endDate || new Date(0)) -
                          (a.endDate || new Date(0))
                      )
                      .slice(0, 1)
                      .map((latestDegree, index) => {
                        return latestDegree?.degree;
                      })[0]);
                break;
              case "experience":
                filteredVal["Experience"] = candidate.candidateId?.experiance;
                break;
              case "gender":
                filteredVal["Gender"] = candidate.candidateId?.gender;
                break;
              case "fullName":
                filteredVal["Full Name"] =
                  `${candidate.candidateId?.firstName} ${candidate.candidateId?.lastName}`;
                break;
              case "currentCandidateCTCType":
                filteredVal["Current CTC Type"] =
                  candidate.currentCandidateCTCType;
                break;
              case "currentCandidateCTC":
                filteredVal["Current CTC"] = candidate.currentCandidateCTC;
                break;
              case "expectedCandidateCTCType":
                filteredVal["Expected CTC Type"] =
                  candidate.expectedCandidateCTCType;
                break;
              case "expectedCandidateCTC":
                filteredVal["Expected CTC"] = candidate.expectedCandidateCTC;
                break;
              case "status":
                filteredVal["Status"] = candidate.status;
                break;
              case "submission_at":
                // Assuming candidate?.created_at contains the ISO 8601 formatted date string
                let isoDate = candidate?.created_at;
                if (isoDate) {
                  let date = new Date(isoDate);
                  let day = date.getUTCDate().toString().padStart(2, "0");
                  let month = (date.getUTCMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  let year = date.getUTCFullYear();
                  let formattedDate = `${day}-${month}-${year}`;
                  filteredVal["Submission date"] = formattedDate;
                }
                break;

              default:
                filteredVal[field] = candidate[field];
            }
          }
        });

        delete filteredVal.Questions;
        delete filteredVal.QnA;

        return filteredVal;
      });

    const ws = XLSX.utils.json_to_sheet(filteredSubmissions);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename + fileExtension);
    const activityOn = `Download excel from submission number of download is ${filteredSubmissions?.length}`;
    const activityDo = `Download excel`;
    const component = "jobpost";
    const reData = {
      name: candidate_ownerName,
      id: userId,
      action: "downloadTemplate",
      type: "candidate",
      ext: "exl"
    }
    userActivity(
      candidate_ownerName,
      userId,
      component,
      activityDo,
      activityOn,
      userRole,
      reData
    );
    handleCloseModal();
  };

  const [sourceData, setSourceData] = useState([]);

  useEffect(() => {
    getSourceData();
    getAllUserTeams()
  }, []);

  const getSourceData = async () => {
    try {
      const response = await axios.get(`${config?.apiUrl}/api/get_source`);
      setSourceData(response.data);
    } catch (error) {
      console.error("Error fetching source data:", error);
    }
  };

  const [selectedWorkCountry, setSelectedWorkCountry] = useState({
    name: "India",
    isoCode: "IN",
  });
  const [selectedWorkState, setSelectedWorkState] = useState(null);
  const [selectedWorkCity, setSelectedorkCity] = useState(null);
  const india = Country.getCountryByCode("IN");
  const [workExperienceFields, setWorkexperienceFields] = useState([
    {
      companyname: "",
      designation: "",
      startDate: "",
      endDate: "",
      country: india.name,
      state: "",
      city: "",
      countryCode: india.isoCode,
      stateCode: "",
      responsibilities: []

    },
  ]);

  const [referenceFields, setReferenceFields] = useState([
    {
      referenceType: "",
      referenceName: "",
      companyName: "",
      designation: "",
      email: "",
      phone: "",
    },
  ]);

  const [searchCandidateName, setSearchCandidateName] = useState("");
  const [searchCandidateDesignation, setSearchCandidateDesignation] =
    useState("");
  const [searchCandidateCity, setSearchCandidateCity] = useState("");
  const [candidateSearchActiveField, setCandidateSearchActiveField] = useState({
    name: "",
    value: "",
  });
  const [searchCandidateLoading, setSearchCandidateLoading] = useState(false);

  const handleFormCandidateChange = (index, event) => {
    let data = [...eductionFields];
    data[index][event.target.name] = event.target.value;
    setEductionFields(data);
  };

  const handleAddEducation = () => {
    let newfield = {
      institutename: "",
      degree: "",
      startDate: "",
      endDate: "",
      percentage: "",
      category: "",
    };
    setEductionFields([...eductionFields, newfield]);
  };

  const handleAddWork = () => {
    let newfield = {
      companyname: "",
      designation: "",
      startDate: "",
      endDate: "",
      country: india.name,
      state: "",
      city: "",
      countryCode: india.isoCode,
      stateCode: "",
      responsibilities: [],
    };
    setWorkexperienceFields([...workExperienceFields, newfield]);
  };

  const handleAddReference = () => {
    let newfield = {
      referenceType: "",
      referenceName: "",
      companyName: "",
      designation: "",
      email: "",
      phone: "",
    };
    setReferenceFields([...referenceFields, newfield]);
  };

  const handleFormChange = (index, event) => {
    let data = [...eductionFields];
    data[index][event.target.name] = event.target.value;
    setEductionFields(data);
    setParsedata(data);
  };

  const handleFormReferenceChange = (index, event) => {
    let data = [...referenceFields];
    data[index][event.target.name] = event.target.value;
    setReferenceFields(data);
    setParsedata(data);
  };

  const handleFormWorkChange = (index, event) => {
    let data = [...workExperienceFields];
    data[index][event.target.name] = event.target.value;
    setWorkexperienceFields(data);
    setParsedata(data);
  };

  const handleFormWorkExpChange = (index, value, action) => {
    let data = [...workExperienceFields];
    if (action.name === "country") {
      data[index].country = value.name;
      data[index].countryCode = value.isoCode;
      data[index].state = null;
      data[index].stateCode = "";
      data[index].city = null;
    } else if (action.name === "state") {
      data[index].state = value.name;
      data[index].stateCode = value.isoCode;
      data[index].city = null;
    } else if (action.name === "city") {
      data[index].city = value.name;
    }
    setWorkexperienceFields(data);
  };

  const handlesearchQueryShow = () => {
    setSearchQuery(true);
  };
  const handlesearchQueryClose = () => {
    setSearchQuery(false);
  };

  const handleChangeCandidateSubmissionPage = (
    event,
    newCandidateSubmissionPage
  ) => {
    setCandidateSubmissionPage(newCandidateSubmissionPage);
    if (
      searchcandidate.length !== 0 ||
      (candidateSearchActiveField.name !== "" &&
        candidateSearchActiveField.value !== "")
    ) {
      filterCandidateData(
        candidateSearchActiveField.value,
        newCandidateSubmissionPage,
        rowsPerCandidateSubmissionPage,
        candidateSearchActiveField.name
      );
    } else {
      filterCandidateData("",
        newCandidateSubmissionPage,
        rowsPerCandidateSubmissionPage
      );
    }
  };

  const handleChangeRowsPerCandidateSubmissionPage = (event) => {
    setRowsPerCandidateSubmissionPage(+event.target.value);
    setCandidateSubmissionPage(0);
    if (
      searchcandidate.length !== 0 ||
      (candidateSearchActiveField.name !== "" &&
        candidateSearchActiveField.value !== "")
    ) {
      filterCandidateData(
        candidateSearchActiveField.value,
        0,
        +event.target.value,
        candidateSearchActiveField.name
      );
    } else {
      filterCandidateData("", 0, +event.target.value);
    }
  };
  const handleSubmitSubmissionShow = () => {
    SetSubmitSubmission(true);
  };
  const handleSubmitSubmissionClose = () => {
    SetSubmitSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      skill: "",
    });
    setId("");
  };
  const [resumeid, setId] = useState("");
  let { id } = useParams();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [jobSubmissionPage, setJobSubmissionPage] = useState(0);
  const [rowsPerJobSubmissionPage, setRowsPerJobSubmissionPage] = useState(10);

  const handleSubmInputs = (e) => {
    let name, value;
    name = e?.target?.name;
    value = e?.target?.value;
    if (name && value) {
      setSubmission({ ...submission, [name]: value });
    } else {
      setSubmission({});
    }
  };

  const saveSubmFile = (e) => {
    setSubmission({
      ...submission,
      fileName: e.target.files[0].name,
      filePath: e.target.files[0].path,
      file: e.target.files[0],
    });
  };

  const handleSearchCandidateShow = () => {
    setSubmission({
      ...submission,
      jobId: jobpost._id,
      Questions: jobpost.question,
      clientId: jobpost?.clientId?._id,
      clientemail: jobpost?.clientId?.email,
      skill: jobpost?.skill,
      submitterName: jobpost?.clientContactName,
    });
    filterCandidateData("", candidatesubmissionpage, rowsPerCandidateSubmissionPage);
    setSearchCandidateModelShow(true);
  };
  const handleSearchCandidateClose = () => {
    setSearchCandidateModelShow(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSendMailShow = () => {
    SetSendMailShow(true);
  };
  const handleSendMailClose = () => {
    SetSendMailShow(false);
    SetToemail("");
    SetCcemail("");
    SetBccemail("");
    SetSubject("");
    SetMailMessage("");
  };

  const handleSubmissionPreviewShow = () => {
    SetSubmissionPreview(true);
  };
  const handleSubmissionPreviewClose = () => {
    SetSubmissionPreview(false);
    setObjectURL("");
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      submitterName: "",
    });
  };

  const handleEditSubmissionShow = () => {
    // SetEditSubmission(true);
    SetSubmitSubmission(true);
    // setId(submission?._id);
  };
  const handleEditSubmissionClose = () => {
    SetEditSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      submitterName: "",
    });
    setId("");
  };

  const handleEditSubmissionStatusShow = () => {
    SetEditSubmissionStatus(true);
  };
  const handleEditSubmissionStatusClose = () => {
    SetEditSubmissionStatus(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      submitterName: "",
    });
  };

  const handleRemoveSubmissionShow = () => {
    SetRemoveSubmission(true);
  };
  const handleRemoveSubmissionClose = () => {
    SetRemoveSubmission(false);
    setSubmission({
      jobId: "",
      clientId: "",
      candidateId: "",
      Questions: "",
      email: "",
      clientemail: "",
      status: "",
      currentCandidateCTCType: "",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "",
      expectedCandidateCTC: "",
      noticePeriod: "",
      relevantExperiance: "",
      availability: "",
      engagement: "",
      locationPreference: "",
      QnA: [],
      submitterName: "",
    });
  };

  const handleCandidateShow = () => {
    SetCandidateShow(true);
    handleSearchCandidateClose();
  };
  const handleCandidateClose = () => {
    formik.resetForm();
    SetCandidateShow(false);
    setResumeFilePath(null);
    setSendMail(false);
    setCandidate({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      status: "",
      skill: "",
      experiance: "",
      designation: "",
      PancardNumber: "",
      AadharcardNumber: "",
      dateofBirth: "",
      gender: "",
      country: "",
      state: "",
      city: "",
      address: "",
      pincode: "",
      source: "",
      candidateStatus: "",
      educationDetails: [],
      workExperience: [],
      reference: [],
    });

    setSelectedCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedWorkCountry({
      name: "India",
      isoCode: "IN",
    });
    setParsedata(null);
    setEductionFields([{}]);
    setSelectedWorkState("");
    setSelectedorkCity("");
    setWorkexperienceFields([
      {
        companyname: "",
        designation: "",
        startDate: "",
        endDate: "",
        country: india.name,
        state: "",
        city: "",
        countryCode: india.isoCode,
        stateCode: "",
        responsibilities: null
      },
    ]);
    setParsedObjectives(null);
    setReferenceFields([{}]);
    setFile("");
    setFileName("");
    setFilePath("");
    handleSearchCandidateShow();
    setSelectedCity(null);
    setSelectedState(null);
  };
  const handleEditShow = () => {
    SetEditShow(true);
  };
  const handleEditClose = () => {
    editFormik.resetForm();
    SetEditShow(false);
    setResumeFilePath(null);
    setSendMail(false);
    setCandiId("");
    setCandidate({
      firstName: "",
      lastName: "",
      email: "",
      status: "",
      skill: "",
      experiance: "",
      designation: "",
      PancardNumber: "",
      AadharcardNumber: "",
      dateofBirth: "",
      gender: "",
      country: "",
      state: "",
      city: "",
      address: "",
      pincode: "",
      source: "",
      educationDetails: [],
      workExperience: [],
      reference: [],
    });
    setId("");
    setSelectedCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedWorkCountry({
      name: "India",
      isoCode: "IN",
    });
    setSelectedWorkState("");
    setSelectedorkCity("");
    setEductionFields([{}]);
    setWorkexperienceFields([
      {
        companyname: "",
        designation: "",
        startDate: "",
        endDate: "",
        country: india.name,
        state: "",
        city: "",
        countryCode: india.isoCode,
        stateCode: "",
        responsibilities: null
      },
    ]);
    setParsedObjectives([]);
    setReferenceFields([{}]);
    handleSearchCandidateShow();
  };

  const handleEditJobShow = () => {
    SetEditJobShow(true);
    getclientsdata();
  };
  const handleEditJobClose = () => {
    formik.resetForm();
    SetEditJobShow(false);
    setSelectedOption(null);
    setSelectedTeamLeader(null);
    setSelectedRecruiter(null);
    setSelectedAccountManager(null);
    setEditJobpost({
      jobtitle: "",
      country: "India",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      accountmanager: "",
      jobdescription: "",
      experience: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
    });
  };

  const handleEditJobInputs = (e) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;

    setEditJobpost({ ...editjobpost, [name]: value });
  };

  const handleViewparseshow = () => {
    setViewparseModel(true);
  };
  const handleViewparseClose = (param) => {
    setViewparseModel(false);
    !param && handleSearchCandidateShow();
  };
  const handleResumeDuplicateshow = () => {
    setResumeDuplicateModel(true);
  };
  const handleResumeDuplicateClose = (param) => {
    setResumeDuplicateModel(false);
    setViewparseModel(false);
    !param && handleSearchCandidateShow();
  };

  const job_ownerName = localStorage?.getItem("candidate_ownerName");
  const job_updateOwnerName = localStorage?.getItem("candidate_ownerName");
  const [updateOwnerName, setUpdateOwnerName] = useState("");

  const editjobFormik = useFormik({
    initialValues: {
      jobtitle: "",
      customer: "",
      country: "India",
      targetdate: "",
      recruiter: "",
      teamleader: "",
      status: "",
      jobtype: "",
      city: "",
      state: "",
      remotestatus: "",
      team: "",
      jobdescription: "",
      experience: "",
      clients: "",
      clientId: "",
      clientContactName: "",
      accountName: "",
      email: "",
      numberofPosition: "",
      skill: "",
      question: "",
      placementType: "",
      clientpayType: "",
      ctc: "",
      onetimeplacementbillType: "",
      onetimeplacementbillValue: "",
      industry: "",
      ownerPhone: "",
      jobAddress: "",
      pincode: ""
    },
    validationSchema: addJobs,
    onSubmit: async (data) => {

      setJobLoading(true);
      const url = `${config?.apiUrl}/api/update_jobpost/${id}`;
      const Credentials = {
        jobtitle: data.jobtitle,
        customer: data.customer,
        country: data.country,
        targetdate: data.targetdate,
        recruiter: selectedRecruiter.value,
        teamleader: selectedTeamLeader.value,
        status: data.status,
        jobtype: data.jobtype,
        city: data.city,
        state: data.state,
        remotestatus: data.remotestatus,
        team: selectedAccountManager.value,
        jobdescription: data.jobdescription,
        experience: data.experience,
        clients: data.clients,
        clientId: data.clientId,
        clientContactName: data.clientContactName,
        numberofPosition: data.numberofPosition,
        skill: data.skill,
        question: data.question,
        placementType: data.placementType,
        clientpayType: data.clientpayType,
        ctc: data.ctc,
        onetimeplacementbillType: data.onetimeplacementbillType,
        onetimeplacementbillValue: data.onetimeplacementbillValue,
        // job_ownerName: job_ownerName,
        job_updateOwnerName: candidate_ownerName,
        job_updateOwnerName_Id: userId,
        industry: data?.industry || "",
        ownerPhone: data?.ownerPhone,
        countryCode: data?.countryCode || selectedState?.countryCode || "IN",
        stateCode: data?.stateCode || selectedState?.isoCode,
        jobAddress: data?.jobAddress || "",
        pincode: data?.pincode || "",
      };
      try {
        const response = await axios.put(url, Credentials);
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        handleEditJobClose();
        // getJobpostdata(page, rowsPerPage, moduleData);
        // handleFilterAllFieldStep("", page, rowsPerPage);

        const data = response?.data?.data;
        const activityOn = `Update ${data?.jobtitle} job `;
        const activityDo = "Update Job";
        const component = "jobpost";
        const reData = {
          name: data?.jobTitle,
          id: data?._id,
          action: 'editJob',
          type: 'job',
          note: null,
        }
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );
        const jbid = response.data.data._id;
        const jobTitle = response?.data?.data?.jobtitle;
        const o = Object.entries(changes).map((value) => {
          return `${value[0]} : ${value[1]}`;
        });
        handleActivitySubmit(
          jbid,
          `Job ${jobTitle} has been edited: ${o.join(" || ")} by "${job_ownerName}"`,
          new Date().getTime(),
          data.clientId
        );
        getJobpost(id);
        setSelectedOption(null);
        setSelectedTeamLeader(null);
        setSelectedRecruiter(null);
        setSelectedAccountManager(null);
        setSelectedClientContactName(null);
        setJobLoading(false);
      } catch (err) {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setJobLoading(false);
      }
    },
  });



  const getjob = async (val) => {
    editjobFormik.setValues({
      jobtitle: val.jobtitle,
      customer: val.customer,
      country: val.country,
      targetdate: val.targetdate,
      recruiter: val.recruiter,
      teamleader: val.teamleader,
      status: val.status,
      jobtype: val.jobtype,
      city: val.city,
      clients: val.clientId._id,
      state: val.state,
      remotestatus: val.remotestatus,
      accountmanager: val.accountmanager,
      jobdescription: val.jobdescription,
      experience: val.experience,
      clientId: val.clientId._id,
      clientContactName: val.clientContactName,
      numberofPosition: val.numberofPosition,
      skill: val.skill,
      question: val.question,
      placementType: val.placementType,
      clientpayType: val.clientpayType,
      ctc: val.ctc,
      onetimeplacementbillType: val.onetimeplacementbillType,
      onetimeplacementbillValue: val.onetimeplacementbillValue,
      job_ownerName: userId,
      industry: val.industry || "",
      ownerPhone: val?.ownerPhone ? val?.ownerPhone : val?.jobOwnerDetails?.phone,
      jobAddress: val?.jobAddress || "",
      pincode: val?.pincode || "",
    });
    setUpdateOwnerName(
      val?.job_updateOwnerName_Id
        ? getOptionById(val.job_updateOwnerName_Id, userNames)?.label
        : getOptionById(val?.job_ownerName_Id, userNames)?.label
    );
    const contacts = await getContactdata(val.clientId._id);
    const formatedContacts = contacts?.length
      ? contacts.map((val) => {
        return {
          label: val.accountOwnerName,
          value: val._id,
        };
      })
      : [];
    const selectedContact = formatedContacts?.find(
      (option) => String(option.value) === String(val.clientContactName_Id)
    );
    setSelectedClientContactName(selectedContact || null);
    setSelectedOption({
      value: val?.clientId?._id,
      email: val?.clientId?.email,
      label: val?.clientId?.accountName,
    });
    const team = alluserTeams.filter((team) => team._id === val.team);
    setSelectedTeamD(team[0]);
    // const contacts =  getContactdata(0,tableRowsPerPage['contact'],val.clientId._id);
    setUpdateOwnerName(
      `${val?.job_owener_data?.firstName} ${val?.job_owener_data?.lastName}`
    );
    setSelectedTeamLeader(getOptionById(val.teamleader_Id, reduxUserNames));
    setSelectedRecruiter(getOptionById(val.recruiter_Id, reduxUserNames));
    setSelectedAccountManager({ value: team[0]?._id, label: team[0]?.teamName });
    const memberIds = team[0]?.membersByLead[val.teamleader_Id];
    const recruiters = team[0]?.members?.filter((recruiter) =>
      memberIds?.includes(recruiter?._id)
    );

    if (recruiters?.length === 0) {
      setRecruiters(selectedTeamD?.members);
    } else {
      // setSelectedRecruiter(null);
      setRecruiters(recruiters);
    }
    setSelectedOption({
      value: val?.clientId?._id,
      email: val?.clientId?.email,
      label: val?.clientId?.accountName,
    });
    setSelectedState({
      name: val?.state,
      countryCode: val?.countryCode,
      isoCode: val?.stateCode,
    });
    setSelectedCity({
      name: val?.city,
      countryCode: val?.countryCode,
      isoCode: val?.stateCode,
    });
    setJobBranch({ label: val?.branch_data?.branchName, value: val?.branch_data?._id });
  };
  const SubmissionPreview = async (submissionid, value) => {
    try {
      const result = await axios.get(
        `${config?.apiUrl}/api/download_Submission_Resume/${submissionid}?id=${userId}`
      );
      setObjectURL(result.data)
      setLoading(false);
      const activityOn = `View resume of candidate ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`;
      const activityDo = `View resume`;
      const component = "candidate";
      const reData = {
        name: `${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
        id: value?.candidateId?._id,
        action: "viewResume",
        type: "candidate",
        note: null,
      };
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData
      );
      // handleActivitySubmit &&
      //   handleActivitySubmit(
      //     value?._id,
      //     `View resume of ${value?.candidateId?.firstName} ${value?.candidateId?.lastName}`,
      //     new Date().getTime(),
      //     candidate_ownerName,
      //     userId      
      //   );
      handleSubmissionPreviewShow(setSubmission(value), setId(value._id));
    } catch (error) {
      setObjectURL("no-resume");
      setLoading(false);
      toast.error("Error while Preview file. Try again later", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const [oldStatus, setOldStatus] = useState("");

  useEffect(() => {
    submissionid && setOldStatus(submission?.status);
  }, [submissionid]);
  const handleEditSubmissionStatus = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const { status } = submission;
    const url = `${config?.apiUrl}/api/appliedjob_update/${submissionid}`;
    const Credentials = { status, candidate_ownerName, userId };
    await axios
      .put(url, Credentials)
      .then(async (response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const resonoseData = response.data.data;
        const candidateId = await resonoseData?.candidateId;
        const updateData = {
          status: resonoseData?.status,
        };
        if (
          resonoseData?.status === "Joined" ||
          resonoseData?.status === "Submitted" ||
          resonoseData?.status === "Client - Submitted" ||
          resonoseData?.status === "Internal-Submitted"
        ) {
          updateData.candidateStatus =
            resonoseData?.status === "Client - Submitted"
              ? "QA Check"
              : resonoseData?.status === "Internal-Submitted"
                ? "Submitted"
                : resonoseData?.status;
        }
        const urls = `${config?.apiUrl}/api/update_candidate/${candidateId}`;
        await axios.put(urls, updateData).then((response) => {
          const mailSend = response.data.data?.sendMail;
          // if (mailSend) {
          //   handleUpdateStatusChangeMailSendToCandidate(
          //     submission,
          //     resonoseData,
          //     oldStatus
          //   );
          // }
        });
        setOldStatus("");
        handleEditSubmissionStatusClose();
        handleFilterAllFieldStep(
          "",
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          submissionModuleData
        );
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const inputElm = document.querySelector("#skill");
  const tagify = new Tagify(inputElm, {
    originalInputValueFormat: (valuesArr) =>
      valuesArr.map((item) => item.value).join(","),
  });

  const inputElm2 = document.querySelector("#question");
  const tagify2 = new Tagify(inputElm2, {
    originalInputValueFormat: (valuesArr2) =>
      valuesArr2.map((item) => item.value).join(","),
  });

  const [deleteLoading, setDeleteLoading] = useState(false)
  const handleDeleteSubmission = async () => {
    try {
      setDeleteLoading(true);
      const url = `${config?.apiUrl}/api/remove_submission/${submissionid}`;
      const response = await axios.delete(url)
      toast.success(response.data.msg, {
        position: toast.POSITION.TOP_RIGHT,
      });
      const activityOn = `Candidate ${submission?.candidateId?.firstName} ${submission?.candidateId?.lastName} submission has been deleted `;
      const activityDo = "Delete Submission";
      const component = "jobpost";
      const reData = {
        name: `${submission?.candidateId?.firstName} ${submission?.candidateId?.lastName}`,
        id: submission?.candidateId?._id,
        action: "deleteSubmission",
        type: "submission",
        note: null,
      };
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData
      );
      setDeleteLoading(false);
      handleRemoveSubmissionClose();
      // getJobSubmissionDetail(
      //   jobSubmissionPage,
      //   rowsPerJobSubmissionPage,
      //   submissionModuleData
      // );
      // handleFilterAllFieldStep("", 0, 10);
      submissionModuleData &&
        (await handleFilterAllFieldStep(
          "",
          page,
          rowsPerPage,
          submissionModuleData.permissions
        ));
    } catch (err) {
      setDeleteLoading(false);
      toast.error(err?.response?.data?.msg || "Please check details", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const getJobpost = (id) => {
    axios
      .get(`${config?.apiUrl}/jobpostview/${id}`)
      .then((response) => {
        const jobpostdata = response.data.data;

        setJobpost(jobpostdata);
        Setjobtitle({
          ...jobpostdata,
          jbt: jobpostdata?.jobtitle,
        });
        setDisplayJobpost(jobpostdata);
        setEditJobpost(jobpostdata);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const getJobActivity = (id) => {
    axios
      .get(`${config?.apiUrl}/api/get_Jobactivities/${id}`)
      .then((response) => {
        const activitydata = response.data.data;
        SetActivity(activitydata);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const saveFile = (e, type) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      document.getElementsByClassName("resumename")[0].style.display = "block";

      if (type == "edit") {
        editFormik.setFieldValue("file", selectedFile);
        editFormik.setFieldValue("fileName", selectedFile.name);
        editFormik.setFieldValue("filePath", selectedFile.path);
      } else {
        formik.setFieldValue("file", selectedFile);
        formik.setFieldValue("fileName", selectedFile.name);
        formik.setFieldValue("filePath", selectedFile.path);
      }
    }
  };

  const parseFile = (e) => {
    if (e.target.files[0]) {
      handleViewparseshow();
      handleSearchCandidateClose();
    }
    setFile(e.target.files[0]);
    setFileName(e.target.files[0]?.name);
    setFilePath(e.target.files[0]?.path);
  };

  const handleInputs = (e) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    setCandidate({ ...candidate, [name]: value });
  };

  const handleSubmissionInputs = (e) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    setSubmission({ ...submission, [name]: value });
  };

  const saveSubmissionFile = (e) => {
    setSubmission({
      ...submission,
      fileName: e.target.files[0].name,
      filePath: e.target.files[0].path,
      file: e.target.files[0],
    });
  };
  const handleAddCandidateEmailSend = async (e) => {
    const { email } = e;
    if (!e) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/addCandidate_EmailSend`, { email: email })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };
  const getCandidatNotes = async (id) => {
    try {
      setNotesLoading(true);
      if (id) {
        const response = await axios.get(
          `${config?.apiUrl}/api/get_Candidate_Note/${id}`
        );
        const notedata = response.data.data;
        setGetNotes(notedata);
        setNotesLoading(false);
      } else {
        setNotesLoading(false);
      }
    } catch (error) {
      setNotesLoading(false);
      toast.error(
        error?.message ||
        "Something happened wrong, please try again after sometime.",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: parsedata?.firstName || "",
      lastName: parsedata?.lastName || "",
      email: parsedata?.email || "",
      phone: parsedata?.phone || "",
      status: "Pending",
      skill: parsedata?.skill || "",
      experiance: "",
      designation: parsedata?.designation || "",
      PancardNumber: "",
      AadharcardNumber: "",
      dateofBirth: "",
      gender: "",
      currentCandidateCTCType: "Annual Salary",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "Annual Salary",
      expectedCandidateCTC: "",
      country: parsedata?.country || "India",
      password: "",
      state: parsedata?.state || "",
      city: parsedata?.city || "",
      address: parsedata?.address || "",
      pincode: "",
      source: "",
      candidateStatus: "Available",
      noticePeriod: "",
      file: null,
      fileName: null,
      filePath: null,
      countryCode: "",
      stateCode: "",
      updatedBy: "",
      industry: "",
    },
    validationSchema: addCandidate,
    onSubmit: async (item) => {
      setCandidateLoading(true);
      const originalDate = moment(item.dateofBirth);
      const formattedDate = originalDate.format("DD/MM/YYYY");
      let data = {
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email?.toLowerCase(),
        phone: item.phone,
        password: item.password,
        status: item.status,
        skill: item.skill,
        experiance: item.experiance,
        designation: item.designation,
        PancardNumber: item.PancardNumber,
        AadharcardNumber: item.AadharcardNumber,
        dateofBirth:
          formattedDate !== "Invalid date"
            ? formattedDate
            : item.dateofBirth || "",
        gender: item.gender,
        country: item.country,
        state: item.state,
        city: item.city,
        address: item.address,
        pincode: item.pincode,
        source: item.source,
        file: item.file,
        fileName: item.fileName,
        filePath: item.filePath,
        candidateStatus: item.candidateStatus,
        educationDetails: JSON.stringify(eductionFields),
        workExperience: JSON.stringify(workExperienceFields),
        reference: JSON.stringify(referenceFields),
        sendMail: sendMail,
        candidate_ownerName: localStorage?.getItem("candidate_ownerName"),
        shortSummary: parseSummary || "",
        currentCandidateCTCType: item?.currentCandidateCTCType,
        currentCandidateCTC: item?.currentCandidateCTC,
        expectedCandidateCTCType: item?.expectedCandidateCTCType,
        expectedCandidateCTC: item?.expectedCandidateCTC,
        noticePeriod: item?.noticePeriod,
        countryCode: item?.countryCode || selectedState?.countryCode || "IN",
        stateCode: item?.stateCode || selectedState?.isoCode,
        updatedBy: localStorage?.getItem("candidate_ownerName"),
        industry: item?.industry,
        objectives: parsedata?.objectives
      };

      let configdata = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      try {
        const result = await axios.post(`${config?.apiUrl}/api/registerCandidate`, data, configdata)
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const note = {
          candidateId: result.data.data._id,
          candidateNote: parseSummary,
          createdBy: userId,
        };
        if (parseSummary) {
          handleCandidateShortSummarySubmit(note);
        }
        const activityOn = `Add New Candidate ${result?.data?.data?.firstName} ${result?.data?.data?.lastName} `;
        const activityDo = "Add New Candidate";
        const component = "jobpost";
        const reData = {
          name: result?.data?.data?.firstName + " " + result?.data?.data?.lastName,
          id: result?.data?.data?._id,
          action: 'addCandidate',
          type: 'candidate',
          note: parseSummary,
          status: result?.data?.data?.status
        }
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole, reData
        );
        setCandidate({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          status: "",
          skill: "",
          experiance: "",
          designation: "",
          PancardNumber: "",
          AadharcardNumber: "",
          dateofBirth: "",
          gender: "",
          country: "",
          state: "",
          city: "",
          address: "",
          pincode: "",
          source: "",
          candidateStatus: "",
          educationDetails: [],
          workExperience: [],
          reference: [],
        });
        handleCandidateClose();
        filterCandidateData(
          "",
          candidatesubmissionpage,
          rowsPerCandidateSubmissionPage
        );
        // if (sendMail) {
        //   handleAddCandidateEmailSend(data);
        // }
        setSendMail(false);
        setResumeFilePath(null);
        const cdid = result.data.data._id;
        const cdname =
          result.data.data.firstName + " " + result.data.data.lastName;
        handleActivitySubmit(
          cdid,
          `Candidate " ${cdname} " has been created by ${candidate_ownerName}`,
          new Date().getTime()
        );
        setCandidateLoading(false);
      } catch (error) {
        toast.error("Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setCandidateLoading(false);
      }

    },
  });
  // For Edit Candidate

  const editFormik = useFormik({
    initialValues: {
      firstName: parsedata?.firstName || "",
      lastName: parsedata?.lastName || "",
      email: parsedata?.email || "",
      phone: parsedata?.phone || "",
      status: "",
      skill: parsedata?.skill || "",
      experiance: "",
      designation: parsedata?.designation || "",
      PancardNumber: "",
      AadharcardNumber: "",
      dateofBirth: "",
      gender: "",
      currentCandidateCTCType: "Annual Salary",
      currentCandidateCTC: "",
      expectedCandidateCTCType: "Annual Salary",
      expectedCandidateCTC: "",
      country: parsedata?.country || "India",
      password: "",
      state: parsedata?.state || "",
      city: parsedata?.city || "",
      address: parsedata?.address || "",
      pincode: "",
      source: "",
      candidateStatus: "Available",
      noticePeriod: "",
      file: null,
      fileName: null,
      filePath: null,
      countryCode: "",
      stateCode: "",
      updatedBy: "",
      industry: "",
    },
    validationSchema: editCandidate,
    onSubmit: async (item) => {
      setCandidateLoading(true);
      try {
        const url = `${config?.apiUrl}/api/update_candidate/${candiId}`;
        const originalDate = moment(item?.dateofBirth);
        const formattedDate = originalDate.format("DD/MM/YYYY");

        let Credentials = {
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email?.toLowerCase(),
          phone: item.phone,
          password: item.password,
          status: item.status,
          skill: item.skill,
          experiance: item.experiance,
          designation: item.designation,
          PancardNumber: item.PancardNumber,
          AadharcardNumber: item.AadharcardNumber,
          dateofBirth:
            formattedDate !== "Invalid date"
              ? formattedDate
              : item.dateofBirth || "",
          gender: item.gender,
          country: item.country,
          state: item.state,
          city: item.city,
          address: item.address,
          pincode: item.pincode,
          source: item.source,
          file: item.file,
          fileName: item.fileName,
          filePath: item.filePath,
          candidateStatus: item.candidateStatus,
          educationDetails: eductionFields,
          workExperience: workExperienceFields,
          reference: referenceFields,
          sendMail: sendMail,
          shortSummary: parseSummary || "",
          currentCandidateCTCType: item?.currentCandidateCTCType,
          currentCandidateCTC: item?.currentCandidateCTC,
          expectedCandidateCTCType: item?.expectedCandidateCTCType,
          expectedCandidateCTC: item?.expectedCandidateCTC,
          noticePeriod: item?.noticePeriod,
          countryCode: item?.countryCode || selectedState?.countryCode || "IN",
          stateCode: item?.stateCode || selectedState?.isoCode,
          updatedBy: localStorage?.getItem("candidate_ownerName"),
          industry: item?.industry,
          objectives: parsedata?.objectives
        };
        const response = await axios.put(url, Credentials);
        const responseData = response?.data?.data;

        toast.success(responseData.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });

        const id = responseData?._id;

        const noteData = await getCandidatNotes(id);
        noteData?.forEach((note) => {
          if (note.noteSubmitter === "Created by system") {
            const editNote = {
              id: note._id,
              candidateNote: parseSummary,
            };
            handleSaveNoteShortSummaryEdit(editNote);
          }
        });
        const activityOn = `Update Candidate ${response?.data?.data?.firstName} ${response?.data?.data?.lastName} `;
        const activityDo = "Update Candidate";
        const component = "jobpost";
        const isUpdate = activityStatus != data.status
        const reData = {
          name: response?.data?.data?.firstName + " " + response?.data?.data?.lastName,
          id: response?.data?.data?._id,
          action: 'editCandidate',
          type: 'candidate',
          note: parseSummary,
          status: isUpdate ? data.status : null,
        }
        userActivity(
          candidate_ownerName,
          userId,
          component,
          activityDo,
          activityOn,
          userRole,
          reData
        );

        handleEditClose();
        filterCandidateData(
          "",
          candidatesubmissionpage,
          rowsPerCandidateSubmissionPage
        );
        setSendMail(false);
        setResumeFilePath(null);
        const cdid = responseData._id;

        const cdName =
          localStorage.getItem("firstname") +
          " " +
          localStorage.getItem("lastname");
        const o = Object.entries(changes).map((value) => {
          return `${value[0]} : ${value[1]}`;
        });
        handleActivitySubmit(
          cdid,
          `Candidate has been edited: ${o.join(" || ")} by "${cdName}"`,
          new Date().getTime()
        );
        setCandidateLoading(false);
      } catch (err) {
        toast.error(err.message || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setCandidateLoading(false);
      }
    },
  });

  const handleDelete = async (e) => {
    e.preventDefault();
    const url = `${config?.apiUrl}/api/revome_candidate/${candiId}`;
    await axios
      .delete(url)
      .then((response) => {
        toast.success(response.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        handleEditClose();
        filterCandidateData(
          "",
          candidatesubmissionpage,
          rowsPerCandidateSubmissionPage
        );
      })
      .catch((err) => {
        toast.error(err || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const [resumeFilePath, setResumeFilePath] = useState(null);

  const handleParseSubmit = async (e) => {
    document.getElementById("resume_parse").disabled = true;
    document.getElementById("parse_text").style.display = "none";
    document.getElementById("parse_loader").style.display = "block";
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", fileName);
    formData.append("filePath", filePath);

    const response = await axios
      .post(`${config?.apiUrl}/api/resumeParse`, formData)
      .then((result) => {
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        const candidateEmail = result?.data?.data?.email;
        if (
          result?.data.err == "Cannot read properties of null (reading '0')"
        ) {
          return (
            toast.error("Email not found in resume or check resume formate", {
              position: toast.POSITION.TOP_RIGHT,
            }),
            handleViewparseClose("addModel"),
            handleCandidateShow(),
            setResumeFilePath(URL.createObjectURL(file))
          );
        }

        setFindCandidate(result?.data?.data?.data);
        if (candidateEmail) {
          handleSearchCandidateClose();
          handleResumeDuplicateshow();
          setLoading(false);
        } else {
          // handleCandidateShow();
          const rdata = result?.data?.data?.data;
          setParsedata(rdata);

          var dob = rdata?.dateofbirth;
          var ndob = dob ? dob?.split("/")?.reverse()?.join("-") : "-";
          const skillsValue = Array.isArray(rdata?.skills)
            ? rdata?.skills.join(", ")
            : rdata?.skills;
          const experienceRange = rdata?.experiencenumber;
          const pSummary = rdata.summary;
          setParseSummary(pSummary);
          const objectives = rdata?.objectives?.length ? rdata?.objectives : null;
          setParsedObjectives(objectives)
          formik.setValues({
            firstName: rdata?.firstname,
            lastName: rdata?.lastname,
            email: rdata?.email?.toLowerCase(),
            phone: rdata?.phone,
            skill: skillsValue,
            address: rdata?.address || "",
            designation: rdata?.designation,
            dateofBirth: ndob,
            state: rdata?.state,
            city: rdata?.city,
            experiance: experienceRange,
            PancardNumber: "",
            AadharcardNumber: "",
            gender: rdata?.gender,
            country: rdata?.country,
            password: "",
            pincode: rdata?.pincode,
            source: "",
            candidateStatus: "Available",
            file: file,
            fileName: fileName,
            filePath: filePath,
            status: "Pending",
            stateCode: rdata?.stateCode,
            countryCode: rdata?.countryCode,
            industry: "",
            noticePeriod: ""
          });
          setSelectedState({
            name: rdata?.state,
            countryCode: rdata?.countryCode,
            isoCode: rdata?.stateCode,
          });
          setSelectedCity({
            name: rdata?.city,
            countryCode: rdata?.countryCode,
            isoCode: rdata?.stateCode,
          });
          setCandidate({
            ...candidate,
            firstName: rdata?.firstname,
            lastName: rdata?.lastname,
            email: rdata?.email,
            phone: rdata?.phone,
            skill: rdata?.skills,
            address: rdata?.address,
            designation: rdata?.designation,
            dateofBirth: ndob,
            state: rdata?.state,
            city: rdata?.city,
            gender: rdata?.gender,
            experiance: experienceRange,
          });
          const selfEduction = Array.isArray(rdata?.education)
            ? rdata?.education
            : [];
          const parseSelfEduction = selfEduction.map((eduction) => {
            return {
              institutename: eduction?.institutename,
              degree: eduction?.degree,
              percentage: eduction?.percentage,
              category: eduction?.category,
              endDate: eduction?.enddate,
            };
          });
          setEductionFields(parseSelfEduction);

          const workExperiences = Array.isArray(rdata?.experience)
            ? rdata?.experience
            : [];

          const parsedWorkExperiences = workExperiences.map((experience) => {
            const isValidStartDate = /^([A-Za-z]{3}) (\d{4})$/.test(
              experience?.startdate
            );

            // If it's a valid start date format, convert it to "YYYY-MM"
            const formattedStartDate = isValidStartDate
              ? (() => {
                const dateObject = new Date(experience?.startdate);
                const year = dateObject.getFullYear();
                const month = (dateObject.getMonth() + 1)
                  .toString()
                  .padStart(2, "0");
                return `${year}-${month}`;
              })()
              : experience?.startdate;

            // Check if the enddate is in the format "Mon YYYY"
            const isValidEndDate = /^([A-Za-z]{3}) (\d{4})$/.test(
              experience?.enddate
            );

            const formattedEndDate = isValidEndDate
              ? (() => {
                const dateObject = new Date(experience?.enddate);
                const year = dateObject.getFullYear();
                const month = (dateObject.getMonth() + 1)
                  .toString()
                  .padStart(2, "0");
                return `${year}-${month}`;
              })()
              : experience?.enddate;

            return {
              companyname: experience?.companyname,
              designation: experience?.designation,
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              country: experience?.country,
              state: experience?.state,
              city: experience?.city,
              countryCode: experience?.countryCode,
              stateCode: experience?.stateCode,
              responsibilities: experience?.responsibilities
            };
          });

          setWorkexperienceFields(parsedWorkExperiences);
          const resumeFile = file;
          setResumeFilePath(URL.createObjectURL(resumeFile));
          setLoading(false);
          handleCandidateShow();
          handleViewparseClose("addModel");
          handleSearchCandidateClose();
        }
      })
      .catch((err) => {
        setLoading(false);
        handleViewparseClose("addModel");
        toast.error(err || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleProceed = async () => {
    switch (radiovalue) {
      case "Add Resume":
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", fileName);
        formData.append("filePath", filePath);
        formData.append("resumeOptions", radiovalue);
        await axios
          .post(`${config?.apiUrl}/api/resumeParse`, formData)
          .then((result) => {
            toast.success(result.data.msg, {
              position: toast.POSITION.TOP_RIGHT,
            });
            handleResumeDuplicateClose();
            handleViewparseClose();
            setFile("");
            setFileName("");
            setFilePath("");
          })
          .catch((err) => {
            toast.error(err || "Please check details", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setLoading(false);
          });
        break;

      case "Add Resume and Update candidate profile":
        document.getElementById("resume_parse").disabled = true;
        document.getElementById("parse_text").style.display = "none";
        document.getElementById("parse_loader").style.display = "block";
        setLoading(true);
        setLoading(true);
        const formData1 = new FormData();
        formData1.append("file", file);
        formData1.append("fileName", fileName);
        formData1.append("filePath", filePath);
        formData1.append("resumeOptions", radiovalue);
        try {
          const response = await axios.get(
            `${config?.apiUrl}/candidateview/${findCandidate?._id}`
          );
          const rdata = response.data.data;
          setParsedata(rdata);
          var dob = rdata?.dateofBirth;

          var ndob = dob ? dob?.split("/")?.reverse()?.join("-") : "";
          const pSummary = rdata.shortSummary;

          setParseSummary(pSummary);
          const objectives = rdata?.objectives?.length ? rdata?.objectives : null;
          setParsedObjectives(objectives)
          setActivityStatus(rdata?.status)
          editFormik.setValues({
            firstName: rdata?.firstName,
            lastName: rdata?.lastName,
            email: rdata?.email?.toLowerCase(),
            phone: rdata?.phone,
            skill: rdata?.skill,
            address: rdata?.address || "",
            designation: rdata?.designation,
            dateofBirth: ndob,
            state: rdata?.state,
            city: rdata?.city,
            experiance: rdata?.experiance,
            PancardNumber: rdata?.PancardNumber || "",
            AadharcardNumber: rdata?.AadharcardNumber || "",
            gender: rdata?.gender || "",
            country: rdata?.country || "India",
            password: "",
            currentCandidateCTCType: "Annual Salary",
            expectedCandidateCTCType: "Annual Salary",
            pincode: rdata?.pincode || "",
            source: rdata?.source || "",
            candidateStatus: rdata?.candidateStatus || "Available",
            file: file,
            fileName: fileName,
            filePath: filePath,
            status: rdata?.status || "Pending",
            noticePeriod: rdata?.noticePeriod || "",
            currentCandidateCTC: rdata?.currentCandidateCTC || "",
            expectedCandidateCTC: rdata?.expectedCandidateCTC || "",
            stateCode: rdata?.stateCode,
            countryCode: rdata?.countryCode,
            industry: rdata?.industry,
          });
          setSelectedState({
            name: rdata?.state,
            countryCode: rdata?.countryCode,
            isoCode: rdata?.stateCode,
          });
          setSelectedCity({
            name: rdata?.city,
            countryCode: rdata?.countryCode,
            isoCode: rdata?.stateCode,
          });
          setCandidate({
            ...candidate,
            firstName: rdata?.firstName,
            lastName: rdata?.lastName,
            email: rdata?.email,
            phone: rdata?.phone,
            skill: rdata?.skill,
            address: rdata?.address || "",
            designation: rdata?.designation,
            dateofBirth: ndob ? ndob : "",
            state: rdata?.state,
            city: rdata?.city,
            pincode: rdata?.pincode || "",
            experiance: rdata?.experiance,
            gender: rdata?.gender || "",
          });

          setEductionFields(
            rdata?.educationDetails || [
              {
                institutename: "",
                degree: "",
                startDate: "",
                endDate: "",
                percentage: "",
                category: "",
              },
            ]
          );

          setWorkexperienceFields(
            rdata?.workExperience || [
              {
                companyname: "",
                designation: "",
                startDate: "",
                endDate: "",
                country: india.name,
                state: "",
                city: "",
                countryCode: india.isoCode,
                stateCode: "",
                responsibilities: null
              },
            ]
          );

          setReferenceFields(
            rdata?.reference || [
              {
                referenceType: "",
                referenceName: "",
                companyName: "",
                designation: "",
                email: "",
                phone: "",
              },
            ]
          );

          const resumeFile = file;
          setResumeFilePath(URL.createObjectURL(resumeFile));
          handleEditShow();
          setCandidate(findCandidate);
          setCandiId(findCandidate?._id);
          handleResumeDuplicateClose("editShow");
          setLoading(false);
        } catch (error) {
          console.log("error::::::::::::", error);
          toast.error(
            error ||
            "Error in the Add Resume and Update candidate profile section",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
          setLoading(false);
        }
        break;
      case "Do not replace the profile":
        const formData2 = new FormData();
        formData2.append("file", file);
        formData2.append("fileName", fileName);
        formData2.append("filePath", filePath);
        formData2.append("resumeOptions", radiovalue);
        await axios
          .post(`${config?.apiUrl}/api/resumeParse`, formData2)
          .then((result) => {
            toast.success(result.data.msg, {
              position: toast.POSITION.TOP_RIGHT,
            });
            handleResumeDuplicateClose();
            handleViewparseClose();
            setFile("");
            setFileName("");
            setFilePath("");
          })
          .catch((err) => {
            toast.error(err || "Please check details", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setLoading(false);
          });
        break;

      default:
        break;
    }
  };

  const handleResumeMatching = async (e) => {
    setLoadingResumeScreening(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", submission?.file);
    formData.append("fileName", submission?.fileName);
    formData.append("filePath", submission?.filePath);
    formData.append("jobRequirement", JSON.stringify(jobpost));
    formData.append("requiredSkill", submission?.skill);

    await axios
      .post(`${config?.apiUrl}/api/resume_screening`, formData)
      .then((result) => {
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
        const pasreConclusion = result.data.data?.conclusion;
        setLoadingResumeScreening(false);
        const requiredSkill = submission?.skill || submission?.candidateId?.skill;
        const rdata = JSON.parse(result.data.data?.jsonResponse);
        const pAge = rdata?.age;
        setParseAge(pAge);
        const percentMatch = result.data.data?.percentageMatch;
        setParsePercentage(percentMatch);
        let parsedSkills = Array.isArray(rdata.skills)
          ? rdata.skills
          : rdata.skills.split(",");

        const requiredSkillsArray = requiredSkill?.split(",");

        const matchedSkills = parsedSkills?.filter((parsedSkill) => {
          return requiredSkillsArray.some((reqSkill) => {
            // Check if the beginning of any word in parsedSkill matches the beginning of reqSkill
            const parsedWords = parsedSkill.toLowerCase().split(" ");
            const reqWords = reqSkill.toLowerCase().split(" ");

            return parsedWords.some((parsedWord) =>
              reqWords.some(
                (reqWord) =>
                  parsedWord.startsWith(reqWord) ||
                  reqWord.startsWith(parsedWord)
              )
            );
          });
        });

        const missingSkills = requiredSkillsArray?.filter(
          (reqSkill) =>
            !matchedSkills.some(
              (matchedSkill) =>
                matchedSkill.toLowerCase().startsWith(reqSkill.toLowerCase()) ||
                reqSkill.toLowerCase().startsWith(matchedSkill.toLowerCase())
            )
        );

        setMatchingSkills(matchedSkills);
        setMissingSkills(missingSkills);
        setParsedSkills(parsedSkills);
        setparseResumeConclusion(pasreConclusion);
        setLoading(false);
        setLoadingResumeScreening(false);
        document.getElementsByClassName("matched_skill")[0].style.display =
          "block";
        document.getElementsByClassName("conclusion")[0].style.display =
          "block";
        if (matchedSkills.length === 0) {
          toast.error("You don't match the required skills.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          // Display toaster for file not found in the database
          toast.error("Resume file not found in the database.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoadingResumeScreening(false);
        } else {
          // Display a general error toaster
          toast.error(
            "Please check your resume or try again later. If the issue persists, please add your resume.",
            {
              position: toast.POSITION.TOP_RIGHT,
            }
          );
          setLoadingResumeScreening(false);
        }
        setLoading(false);
        setLoadingResumeScreening(false);
      });
  };
  const handleJobActivitySubmit = async (
    _jbid,
    _activityDes,
    _created_at,
    _clientId
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Jobactivities`, {
        jobId: _jbid,
        jobActivity: _activityDes,
        created_at: _created_at,
        clientId: _clientId,
      })
      .then((result) => {
        toast.success(result.data.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const handleActivitySubmit = async (_cdid, _activityDes, _created_at) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Candidateactivities`, {
        candidateId: _cdid,
        jobActivity: _activityDes,
        created_at: _created_at,
      })
      .then((result) => {
        console.log("success activity");
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleCandidateActivitySubmit = async (
    candidateId,
    _activityDes,
    _created_at,
    _submitterName,
    userId
  ) => {
    const response = await axios
      .post(`${config?.apiUrl}/api/Set_Candidateactivities`, {
        candidateId: candidateId,
        jobActivity: _activityDes,
        created_at: _created_at,
        submittedBy: _submitterName,
        submittedById: userId
      })
      .then((result) => {
        console.log("success activity");
        // toast.success(result.data.msg, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || "Please check details", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleAppliedJobClientEmailSend = async (formData) => {
    const { clientemail, email, clientId, jobId } = formData;
    const jobDetails = jobposts.find((job) => job._id === jobId);
    const jobTitle = jobDetails?.jobtitle;

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_Client_EmailSend`, {
        email: clientemail,
        candidateEmail: email,
        clientId: clientId,
        jobTitle: jobTitle,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const handleAppliedJobEmailSend = async (formData) => {
    const { email, jobId } = formData;

    const jobDetails = jobposts.find((job) => job._id === jobId);

    if (!formData) {
      toast.error("Invalid credentials", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const response = await axios
      .post(`${config?.apiUrl}/api/Job_Applied_EmailSend`, {
        email: email,
        jobDetails: jobDetails,
      })
      .then((result) => {
        toast.success(result?.data?.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.msg ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const filterCandidateData = async (
    string = "",
    page = 0,
    limit = 10,
    fieldName
  ) => {
    const url = `${config?.apiUrl}/api/get_all_search_candidate`;

    const queryObject = {
      page: page + 1,
      limit: limit,
      firstName: searchCandidateName,
      city: searchCandidateCity,
      candidate_ownerName:
        fieldName == "candidate_ownerName"
          ? string
          : searchCandidateOwnerName?.value || "",
      text: searchcandidate,
      designation: searchCandidateDesignation,
      candidate_id: uniqueCandidateId,
    };

    try {
      setSearchCandidateLoading(true);
      const filterdata = await axios.post(url, queryObject, {
        headers: {
          Authorization: `Bearer ${cookie.token}`,
          "Content-Type": "application/json",
        },
      });

      let temp = filterdata.data.data;

      const totalCandidates = filterdata.data.totalCandidates;
      temp.totalCandidates = totalCandidates;
      setCandidates(temp);
      setSearchCandidateLoading(false);
    } catch (error) {
      toast.error(error, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setSearchCandidateLoading(false);
    }
  };


  const clearCandidateSearchFilter = () => {
    setSearchcandidate("");
    setSearchCandidateName("");
    setCandidateSearchActiveField({ name: "", value: "" });
    setSearchCandidateDesignation("");
    setSearchCandidateCity("");
    setSearchCandidateOwnerName(null);
    filterCandidateData("", candidatesubmissionpage, rowsPerCandidateSubmissionPage);
  };

  const handleLinkUpdate = (e) => {
    let name, value;
    name = e.target.name;
    value = e.target.value;
    setDisplayJobpost({ ...displayjobpost, [name]: value });
  };

  const handleUrlUpdate = (e) => {
    const { name, value } = e.target;
    setLinkedinUrl((prevState) => ({
      ...prevState,
      [name]: value?.toString(),
    }));
  };

  const [allUsers, setAllusers] = useState([]);

  const getalluser = () => {
    axios
      .get(`${config?.apiUrl}/api/get_all_users`)
      .then((response) => {
        const recruiterData = response.data.data;
        setAllusers(recruiterData);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const getclientsdata = () => {
    axios
      .get(`${config?.apiUrl}/api/get_all_clients`)
      .then((response) => {
        const clientsData = response.data.data;
        setClients(clientsData);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };


  const handlelinkedin = () => {
    const { city, jobtitle, skill, currentcompanyname } = displayjobpost;

    // Split and clean data
    const cityList = city
      ? city.split(",").map((e) => e.trim().replace(/\s/g, "+"))
      : [];
    const skillList = skill
      ? skill.split(",").map((e) => e.trim().replace(/\s/g, "+"))
      : [];

    // Build LinkedIn search query
    let query = `q=+"${jobtitle.replace(/\s/g, "+")}"+`;

    // Add location filter
    if (cityList.length) {
      query += ` AND ("${cityList.join('" OR "')}"+)`;
    }

    // Add skill filters (AND/OR based on your preference)
    if (skillList.length) {
      query += ` AND ("${skillList.join('" OR "')}"+)`;
    }

    // Include company filter if present
    if (currentcompanyname) {
      query += ` AND ("${currentcompanyname.replace(/\s/g, "+")}"+)`;
    }

    // Build complete URL
    const linkedIn_url = `http://www.google.com/search?${query} -intitle:"profiles" -inurl:"dir/+"+site:in.linkedin.com/in/+OR+site:in.linkedin.com/pub/`;

    // Set LinkedIn URL
    setLinkedinUrl(linkedIn_url);

    const activityOn = `Find the right people on LinkedIn for ${jobpost?.jobtitle}`;
    const activityDo = "View Candidate on LinkedIn";
    const component = "jobpost";
    const reData = {
      name: jobpost?.jobtitle,
      id: jobpost?._id,
      action: 'viewCandidate',
      type: 'candidate',
      note: null,
    }
    userActivity(
      candidate_ownerName,
      userId,
      component,
      activityDo,
      activityOn,
      userRole,
      reData
    );
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(linkedinUrl);
    toast.success("URL copied to clipboard", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    // Set Formik field values
    editjobFormik.setFieldValue("accountName", selectedOption.label);
    editjobFormik.setFieldValue("clientId", selectedOption.value);
    editjobFormik.setFieldValue("email", selectedOption.email);
    editjobFormik.setFieldValue("clients", selectedOption.label);
    getContactdata(selectedOption.value);
  };

  const options = clients.map((client) => ({
    value: client._id,
    label: client.accountName,
    email: client.email,
  }));

  const getCandidateApplicationStatus = async () => {
    await axios
      .get(`${config.apiUrl}/api/get_All_candidate_application_status`)
      .then((response) => {
        const statusData = response.data.data;
        setApplicationStatus(statusData);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const getCandidateStatus = () => {
    axios
      .get(`${config?.apiUrl}/api/get_All_candidate_status`)
      .then((response) => {
        const statusdata = response.data.data;
        setCandidateStatus(statusdata);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error ||
          "Something happened wrong, please try again after sometime.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      });
  };

  const [searchfname, setSearchFname] = useState("");
  const [searchlname, setSearchLname] = useState("");
  const [searchjobt, setSearchJobt] = useState("");
  const [searchstatus, setSearchStatus] = useState([]);
  const [searchcustomer, setSearchCustomer] = useState([]);
  const [searchOwnerName, setSearchOwnerName] = useState([]);
  const [searchcandidatectctype, setSearchCandidatectctype] = useState("");
  const [searchcandidatectc, setSearchCandidatectc] = useState("");
  const [searchcity, setSearchCity] = useState([]);
  const [searchstate, setSearchstate] = useState([]);
  const [searchSubmissionDate, setSearchSubmissionDate] = useState([]);
  const [searchSubmissionUpdateDate, setSearchSubmissionUpdateDate] = useState(
    []
  );
  const [searchExpectedCandidateCTC, setSearchExpectedCandidateCTC] =
    useState("");
  const [searchExpectedCandidateCTCType, setSearchExpectedCandidateCTCType] =
    useState("");
  const [searchNoticePeriod, setSearchNoticePeriod] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [searchAddress, setSearchAddress] = useState("");
  const [searchDOB, setSearchDOB] = useState("");
  const [searchAadharCardNumber, setSearchAadharCardNumber] = useState("");
  const [searchPanCardNumber, setSearchPanCardNumber] = useState("");
  const [searchDesignation, setSearchDesignation] = useState("");
  const [searchWorkExperience, setSearchWorkExperience] = useState("");
  const [searchEducationDetails, setSearchEducationDetails] = useState("");
  const [searchExperience, setSearchExperience] = useState(null);
  const [searchGender, setSearchGender] = useState("");
  const [searchInterviewScheduleDate, setSearchInterviewScheduleDate] =
    useState([]);
  const [searchInterviewScheduleTime, setSearchInterviewScheduleTime] =
    useState("");
  const [searchInterviewScheduleLocation, setSearchInterviewScheduleLocation] =
    useState("");
  const [searchInterviewScheduleLink, setSearchInterviewScheduleLink] =
    useState("");
  const [searchJoinDate, setSearchJoinDate] = useState([]);
  const [searchSubmissionBy, setSearchSubmissionBy] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchContactName, setSearchContactName] = useState("");
  const [activeField, setActiveField] = useState({ name: "", value: "" });
  const [searchActualCTC, setSearchActualCTC] = useState("");
  const [searchOfferCTC, setSearchOfferCTC] = useState("");
  const [searchExpectedJoinDate, setSearchExpectedJoinDate] = useState([]);
  const [searchUpdatedBy, setSearchUpdatedBy] = useState([]);
  const [searchFullName, setSearchFullName] = useState("");
  const [searchIndustry, setSearchIndustry] = useState([]);
  const [searchInterviewRescheduleDate, setSearchInterviewRescheduleDate] =
    useState([]);
  const [searchTestRescheduleDate, setSearchTestRescheduleDate] = useState([]);
  const [searchBackoutDate, setSearchBackoutDate] = useState([]);

  const [
    isFilterActiveBackoutDate,
    setIsFilterActiveBackoutDate,
  ] = useState(false);
  const [
    isFilterActiveTestRescheduleDate,
    setIsFilterActiveTestRescheduleDate,
  ] = useState(false);
  const [
    isFilterActiveInterviewRescheduleDate,
    setIsFilterActiveInterviewRescheduleDate,
  ] = useState(false);
  const [isFilterActiveIndustry, setIsFilterActiveIndustry] = useState(false);
  const [isFilterActiveFullName, setIsFilterActiveFullName] = useState(false);
  const [isFilterActiveUpdatedBy, setIsFilterActiveUpdatedBy] = useState(false);
  const [isFilterActiveExpectedJoinDate, setIsFilterActiveExpectedJoinDate] =
    useState(false);
  const [isFilterActiveUpdatedDate, setIsFilterActiveUpdatedDate] =
    useState(false);
  const [isFilterActiveOfferCTC, setIsFilterActiveOfferCTC] = useState(false);
  const [isFilterActiveActualCTC, setIsFilterActiveActualCTC] = useState(false);
  const [isFilterActiveEmail, setIsFilterActiveEmail] = useState(false);
  const [isFilterActiveSubmissionBy, setIsFilterActiveSubmissionBy] =
    useState(false);
  const [isFilterActiveJoinDate, setIsFilterActiveJoinDate] = useState(false);
  const [
    isFilterActiveInterviewScheduleLink,
    setIsFilterActiveInterviewScheduleLink,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleLocation,
    setIsFilterActiveInterviewScheduleLocation,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleTime,
    setIsFilterActiveInterviewScheduleTime,
  ] = useState(false);
  const [
    isFilterActiveInterviewScheduleDate,
    setIsFilterActiveInterviewScheduleDate,
  ] = useState(false);
  const [isFilterActiveGender, setIsFilterActiveGender] = useState(false);
  const [isFilterActiveExperience, setIsFilterActiveExperience] =
    useState(false);
  const [isFilterActiveEducationDetails, setIsFilterActiveEducationDetails] =
    useState(false);
  const [isFilterActiveWorkExperience, setIsFilterActiveWorkExperience] =
    useState(false);
  const [isFilterActiveDesignation, setIsFilterActiveDesignation] =
    useState(false);
  const [isFilterActivePanCardNumber, setIsFilterActivePanCardNumber] =
    useState(false);
  const [isFilterActiveAadharCardNumber, setIsFilterActiveAadharCardNumber] =
    useState(false);
  const [isFilterActiveDOB, setIsFilterActiveDOB] = useState(false);
  const [isFilterActiveAddress, setIsFilterActiveAddress] = useState(false);
  const [isFilterActivePhone, setIsFilterActivePhone] = useState(false);
  const [isFilterActiveNoticePeriod, setIsFilterActiveNoticePeriod] =
    useState(false);
  const [isFilterActivEexpectedCtctype, setIsFilterActiveExpectedCtctype] =
    useState(false);
  const [isFilterActiveExpectedCtc, setIsFilterActiveExpectedCtc] =
    useState(false);
  const [isFilterActiveFname, setIsFilterActiveFname] = useState(false);
  const [isFilterActiveLname, setIsFilterActiveLname] = useState(false);
  const [isFilterActiveJobt, setIsFilterActiveJobt] = useState(false);
  const [isFilterActiveStatus, setIsFilterActiveStatus] = useState(false);
  const [isFilterActiveClient, setIsFilterActiveClient] = useState(false);
  const [isFilterActiveOwner, setIsFilterActiveOwner] = useState(false);
  const [isFilterActiveCtctype, setIsFilterActiveCtctype] = useState(false);
  const [isFilterActiveCtc, setIsFilterActiveCtc] = useState(false);
  const [isFilterActiveCity, setIsFilterActiveCity] = useState(false);
  const [isFilterActiveState, setIsFilterActiveState] = useState(false);
  const [isFilterActiveDate, setIsFilterActiveDate] = useState(false);
  const [isFilterActiveContactName, setIsFilterActiveContactName] =
    useState(false);

  const statusField = "all";
  const [mySubmissionValue, setMySubmissionValue] = useState("");
  const [popoverVisible, setPopoverVisible] = useState({});
  const [popoverVisibleInterview, setPopoverVisibleInterview] = useState({});
  // Close filter modal popover
  const handlePopOverClose = (key, visibility) => {
    const newPopoverVisible = key
      ? { ...popoverVisible, [key]: visibility }
      : {};
    setPopoverVisible(newPopoverVisible);
  };
  const handlePopOverinterviewClose = (key, visibility) => {
    const newPopoverVisible = key
      ? { ...popoverVisibleInterview, [key]: visibility }
      : {};
    setPopoverVisibleInterview(newPopoverVisible);
  };

  const handleFilterAllFieldStep = async (
    string = "",
    page = 0,
    rowsPerPage = 10,
    fieldName
  ) => {
    const isClientView = true;
    const clientId = jobpost?.clientId?._id;
    const contactId = jobpost?.clientContactName;
    const jobId = jobpost?.jobtitle;
    const jobDocId = jobpost?._id;
    const submissionByTeamSearch = teamData.filter((name) =>
      string?.includes(name)
    );
    const url = `${config?.apiUrl}/api/get_All_search_submission?page=${page + 1}&limit=${rowsPerPage}&candidateFirstName=${fieldName == "candidateFirstName" ? string : searchfname}&candidateLastName=${fieldName == "candidateLastName" ? string : searchlname}&candidateSource=${fieldName == "candidateSource" ? string : searchSourceData}&email=${fieldName == "email" ? string : searchEmail}&status=${fieldName == "status" ? string : searchstatus}&ownerName=${fieldName == "ownerName" ? string : searchOwnerName || ""
      }&currentCandidateCTC=${fieldName == "currentCandidateCTC" ? string : searchcandidatectc}&expectedCandidateCTC=${fieldName == "expectedCandidateCTC" ? string : searchExpectedCandidateCTC}&currentCandidateCTCType=${fieldName == "currentCandidateCTCType" ? string : searchcandidatectctype}&expectedCandidateCTCType=${fieldName == "expectedCandidateCTCType" ? string : searchExpectedCandidateCTCType}&city=${fieldName == "city" ? string : searchcity || ""}&state=${fieldName == "state" ? string : searchstate || ""}&noticePeriod=${fieldName == "noticePeriod" ? string : searchNoticePeriod && `${searchNoticePeriod?.noticePeriod[0] || 0}-${searchNoticePeriod?.noticePeriod[1]}`}&address=${fieldName == "address" ? string : searchAddress}&DOB=${fieldName == "DOB" ? string : searchDOB}&pancardNumber=${fieldName == "pancardNumber" ? string : searchPanCardNumber}&aadharcardNumber=${fieldName == "aadharcardNumber" ? string : searchAadharCardNumber}&gender=${fieldName == "gender" ? string : searchGender}&workExperience=${fieldName == "workExperience" ? string : searchWorkExperience}&educationDetails=${fieldName == "educationDetails" ? string : searchEducationDetails}&submissionBy=${fieldName == "submissionBy"
        ? string || ""
        : userRole !== "Admin" ? userId : ""
      // cookie?.role != "Admin"
      //   ? moduleData?.view == "ownrecords"
      //     ? candidate_ownerName?.trim()
      //     : moduleData?.view == "ownandteamrecords"
      //       ? fieldName == "submissionBy"
      //         ? teamData && Array.isArray(string)
      //           ? submissionByTeamSearch?.length == 0
      //             ? null
      //             : submissionByTeamSearch
      //           : string
      //             ? string
      //             : teamData
      //         : searchSubmissionBy.length !== 0
      //           ? searchSubmissionBy
      //           : teamData
      //             ? teamData
      //             : null
      //       : fieldName == "submissionBy"
      //         ? string || ""
      //         : searchSubmissionBy || ""
      //   : fieldName == "submissionBy"
      //     ? string || ""
      //     : searchSubmissionBy || ""
      }&statusField=${statusField !== undefined ? statusField : ""}&interviewScheduleDate=${fieldName == "interviewScheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewScheduleDate || ""}&interviewScheduleTime=${fieldName == "interviewScheduleTime" ? string : searchInterviewScheduleTime}&interviewScheduleLocation=${fieldName == "interviewScheduleLocation" ? string : searchInterviewScheduleLocation}&interviewScheduleLink=${fieldName == "interviewScheduleLink" ? string : searchInterviewScheduleLink}&joinDate=${fieldName == "joinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchJoinDate || ""}&actualCTC=${fieldName == "actualCTC" ? string : searchActualCTC}&expectedJoinDate=${fieldName == "expectedJoinDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchExpectedJoinDate || ""}&offerCTC=${fieldName == "offerCTC" ? string : searchOfferCTC}&isClientView=${isClientView !== undefined ? isClientView : ""}&updatedBy=${fieldName == "updatedBy" ? string : searchUpdatedBy || ""}&candidateFullName=${fieldName == "candidateFullName" ? string : searchFullName}&industry=${fieldName == "industry" ? string : searchIndustry || ""}&createdAt=${fieldName == "created_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionDate || ""}&updatedAt=${fieldName == "updated_at" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchSubmissionUpdateDate || ""}&interviewRescheduleDate=${fieldName == "interviewRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchInterviewRescheduleDate || ""}&testRescheduleDate=${fieldName == "testRescheduleDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchTestRescheduleDate || ""}&backoutDate=${fieldName == "backoutDate" ? (string?.startDate && string?.endDate ? [string?.startDate, string?.endDate] : "") : searchBackoutDate || ""}`;

    const queryObject = {
      searchText: fieldName == "text" ? string : searchAllSubmissionfields,
      jobtitle: fieldName == "jobtitle"
        ? string
        : searchjobt,
      // jobId !== undefined
      //   ? jobId
      //   : fieldName == "jobtitle"
      //     ? string
      //     : searchjobt,
      designation: fieldName == "designation" ? string : searchDesignation,
      phone: fieldName == "phone" ? string : searchPhone,
      submissionId: fieldName == 'submission_id' ? string : searchSubmissionId,
      branch: fieldName == "branch" ? string : searchBranch,
      experienceMin:
        fieldName == "experience"
          ? string?.experience && string?.experience[0] !== undefined &&
            string?.experience[0] !== null &&
            (!isNaN(string?.experience[0]) || string?.experience[0] === 0)
            ? string?.experience[0]
            : null
          : searchExperience?.experience[0] !== undefined &&
            searchExperience?.experience[0] !== null &&
            (!isNaN(searchExperience?.experience[0]) || searchExperience?.experience[0] === 0)
            ? searchExperience?.experience[0]
            : null,
      experienceMax:
        fieldName == "experience"
          ? string?.experience && string?.experience[1] !== undefined &&
            string?.experience[1] !== null &&
            (!isNaN(string?.experience[1]) || string?.experience[1] === 0)
            ? string?.experience[1]
            : null
          : searchExperience?.experience[1] !== undefined &&
            searchExperience?.experience[1] !== null &&
            (!isNaN(searchExperience?.experience[1]) || searchExperience?.experience[1] === 0)
            ? searchExperience?.experience[1]
            : null,
      jobDocId: id,
      clientName: fieldName == "clientName" ? string : searchcustomer || ""

      // clientId !== undefined
      //   ? clientId
      //   : fieldName == "clientName"
      //     ? string
      //     : searchcustomer || "",
    };

    try {
      setSubmissionLoading(true);
      const filterdata = await axios.get(url, {
        params: queryObject,
        headers: {
          Authorization: `Bearer ${cookie?.token}`,
          "Content-Type": "application/json",
        },
      });

      const allSubmissionData = filterdata.data.data;
      const totalSubmissionCount = filterdata.data.totalSubmissionCount;
      allSubmissionData.totalSubmissionCount = totalSubmissionCount;
      setAppliedJob(allSubmissionData)
      handlePopOverClose(false);
      handlePopOverinterviewClose(false);
      // setDisplaySubmissions(allSubmissionData);
      setDisplayAppliedJob(allSubmissionData);
      setSubmissionLoading(false);
      return allSubmissionData;
    } catch (error) {
      toast.error(error?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      handlePopOverClose(false);
      handlePopOverinterviewClose(false);
      setSubmissionLoading(false);
    }
  };
  const filterData = async (filterValue, filterField, filterDate) => {
    switch (filterField) {
      case "industry":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "industry"
        );
        setIsFilterActiveIndustry(filterValue?.length !== 0 ? true : false);
        break;
      case "branch":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "branch",
        );
        setIsFilterActiveBranch(filterValue?.length == 0 ? false : true);
        break;
      case "firstName":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "candidateFirstName"
        );
        setIsFilterActiveFname(filterValue?.length == 0 ? false : true);
        break;
      case "fullName":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "candidateFullName"
        );
        setIsFilterActiveFullName(filterValue?.length == 0 ? false : true);
        break;

      case "lastName":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "candidateLastName"
        );
        setIsFilterActiveLname(filterValue?.length == 0 ? false : true);
        break;

      case "email":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "email"
        );
        setIsFilterActiveEmail(filterValue?.length == 0 ? false : true);

        break;

      case "jobTitle":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "jobtitle"
        );
        setIsFilterActiveJobt(filterValue?.length == 0 ? false : true);
        break;

      case "status":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "status"
        );
        setIsFilterActiveStatus(filterValue?.length == 0 ? false : true);
        break;

      case "client":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "clientName"
        );
        setIsFilterActiveClient(filterValue?.length == 0 ? false : true);
        break;

      case "contactName":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "contactName"
        );
        setIsFilterActiveContactName(filterValue?.length == 0 ? false : true);
        break;

      case "owner_name":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "ownerName"
        );
        setIsFilterActiveOwner(filterValue?.length == 0 ? false : true);

        break;

      case "currentCandidateCTCType":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "currentCandidateCTCType"
        );
        setIsFilterActiveCtctype(filterValue?.length !== 0 ? true : false);
        break;

      case "currentCandidateCTC":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "currentCandidateCTC"
        );
        setIsFilterActiveCtc(filterValue?.length !== 0 ? true : false);
        break;

      case "expectedCandidateCTCType":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "expectedCandidateCTCType"
        );
        setIsFilterActiveExpectedCtctype(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "expectedCandidateCTC":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "expectedCandidateCTC"
        );
        setIsFilterActiveExpectedCtc(filterValue?.length !== 0 ? true : false);
        break;

      case "city":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "city"
        );
        setIsFilterActiveCity(filterValue?.length !== 0 ? true : false);
        break;

      case "phone":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "phone"
        );
        setIsFilterActivePhone(filterValue?.length !== 0 ? true : false);
        break;

      case "state":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "state"
        );
        setIsFilterActiveState(filterValue?.length !== 0 ? true : false);
        break;

      case "noticePeriod":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "noticePeriod"
        );
        setIsFilterActiveNoticePeriod(filterValue && filterValue.length > 0 ? filterValue[0] : null);
        break;

      case "address":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "address"
        );
        setIsFilterActiveAddress(filterValue?.length !== 0 ? true : false);
        break;

      case "DOB":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "DOB"
        );
        setIsFilterActiveDOB(filterValue?.length !== 0 ? true : false);
        break;

      case "pancardNumber":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "pancardNumber"
        );
        setIsFilterActivePanCardNumber(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "aadharcardNumber":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "aadharcardNumber"
        );
        setIsFilterActiveAadharCardNumber(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "designation":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "designation"
        );
        setIsFilterActiveDesignation(filterValue?.length !== 0 ? true : false);
        break;

      case "experience":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "experience"
        );
        setIsFilterActiveExperience(filterValue && filterValue.experience && typeof filterValue?.experience[0] == 'number' ? filterValue?.experience : null);
        break;

      case "gender":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "gender"
        );
        setIsFilterActiveGender(filterValue?.length !== 0 ? true : false);
        break;

      case "workExperience":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "workExperience"
        );
        setIsFilterActiveWorkExperience(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "educationDetails":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "educationDetails"
        );
        setIsFilterActiveEducationDetails(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "submissionBy":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "submissionBy"
        );
        setIsFilterActiveSubmissionBy(filterValue?.length !== 0 ? true : false);
        break;

      case "interviewScheduleDate":
        const { startDate, endDate } = filterValue;
        await handleFilterAllFieldStep(
          { startDate, endDate },
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "interviewScheduleDate"
        );
        setIsFilterActiveInterviewScheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;

      case "interviewScheduleTime":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "interviewScheduleTime"
        );
        setIsFilterActiveInterviewScheduleTime(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "interviewScheduleLocation":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "interviewScheduleLocation"
        );
        setIsFilterActiveInterviewScheduleLocation(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "interviewScheduleLink":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "interviewScheduleLink"
        );
        setIsFilterActiveInterviewScheduleLink(
          filterValue?.length !== 0 ? true : false
        );
        break;

      case "joinDate":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "joinDate"
        );
        setIsFilterActiveJoinDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "expectedJoinDate":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "expectedJoinDate"
        );
        setIsFilterActiveExpectedJoinDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "actualCTC":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "actualCTC"
        );
        setIsFilterActiveActualCTC(filterValue?.length !== 0 ? true : false);
        break;
      case "offerCTC":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "offerCTC"
        );
        setIsFilterActiveOfferCTC(filterValue?.length !== 0 ? true : false);
        break;

      case "created_at":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "created_at"
        );
        setIsFilterActiveDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "updated_at":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "updated_at"
        );
        setIsFilterActiveUpdatedDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "updatedBy":
        await handleFilterAllFieldStep(
          filterValue,
          jobSubmissionPage,
          rowsPerJobSubmissionPage,
          "updatedBy"
        );
        setIsFilterActiveUpdatedBy(filterValue?.length !== 0 ? true : false);
        break;
      case "interviewRescheduleDate":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "interviewRescheduleDate"
        );
        setIsFilterActiveInterviewRescheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "testRescheduleDate":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "testRescheduleDate"
        );
        setIsFilterActiveTestRescheduleDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "backoutDate":
        await handleFilterAllFieldStep(
          { startDate: filterValue?.startDate, endDate: filterValue?.endDate },
          page,
          rowsPerPage,
          "backoutDate"
        );
        setIsFilterActiveBackoutDate(
          filterValue?.startDate && filterValue?.endDate ? true : false
        );
        break;
      case "source":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "candidateSource"
        );
        setIsFilterActiveSourceSearch(filterValue?.length !== 0 ? true : false);
        break;
      case "submission_id":
        await handleFilterAllFieldStep(
          filterValue,
          page,
          rowsPerPage,
          "submission_id"
        );
        setIsFilterActiveSubmissionId(
          filterValue?.length !== 0 ? true : false
        );
        break;
      default:
        break;
    }
  };

  const clearFilter = () => {
    setIsFilterActiveSubmissionId(false)
    setSearchSubmissionId("")
    setSearchAllSubmissionfields("");
    setSearchFname("");
    setSearchLname("");
    setSearchJobt("");
    setSearchStatus([]);
    setSearchCustomer([]);
    setSearchOwnerName([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchCity([]);
    setSearchContactName("");
    setSearchstate([]);
    setSearchCandidatectctype("");
    setSearchCandidatectc("");
    setSearchNoticePeriod("");
    setSearchPhone("");
    setIsFilterActiveSourceSearch(false);
    setSearchSourceData([]);
    setSearchAddress("");
    setSearchDOB("");
    setSearchAadharCardNumber("");
    setSearchPanCardNumber("");
    setSearchDesignation("");
    setSearchWorkExperience("");
    setSearchEducationDetails("");
    setSearchExperience(null);
    setSearchGender("");
    setSearchInterviewScheduleDate([]);
    setSearchSubmissionDate([]);
    setSearchSubmissionUpdateDate([]);
    setSearchInterviewScheduleLink("");
    setSearchInterviewScheduleLocation("");
    setSearchInterviewScheduleTime("");
    setSearchJoinDate([]);
    setSearchSubmissionBy([]);
    setSearchEmail("");
    setActiveField({ name: "", value: "" });
    setSearchActualCTC("");
    setSearchOfferCTC("");
    setSearchExpectedJoinDate([]);
    setSearchUpdatedBy([]);
    setMySubmissionValue("");
    setSearchFullName("");
    setSearchIndustry([]);
    setSearchInterviewRescheduleDate([]);
    setSearchTestRescheduleDate([]);
    setSearchBackoutDate([])

    setIsFilterActiveBackoutDate(false)
    setIsFilterActiveTestRescheduleDate(false);
    setIsFilterActiveInterviewRescheduleDate(false);
    setIsFilterActiveIndustry(false);
    setIsFilterActiveFullName(false);
    setIsFilterActiveUpdatedBy(false);
    setIsFilterActiveUpdatedDate(false);
    setIsFilterActiveExpectedJoinDate(false);
    setIsFilterActiveOfferCTC(false);
    setIsFilterActiveActualCTC(false);
    setIsFilterActiveEmail(false);
    setIsFilterActiveSubmissionBy(false);
    setIsFilterActiveJoinDate(false);
    setIsFilterActiveInterviewScheduleTime(false);
    setIsFilterActiveInterviewScheduleLocation(false);
    setIsFilterActiveInterviewScheduleLink(false);
    setIsFilterActiveInterviewScheduleDate(false);
    setIsFilterActiveGender(false);
    setIsFilterActiveExperience(false);
    setIsFilterActiveEducationDetails(false);
    setIsFilterActiveWorkExperience(false);
    setIsFilterActiveContactName(false);
    setIsFilterActiveDesignation(false);
    setIsFilterActivePanCardNumber(false);
    setIsFilterActiveAadharCardNumber(false);
    setIsFilterActiveDOB(false);
    setIsFilterActiveAddress(false);
    setIsFilterActivePhone(false);
    setIsFilterActiveNoticePeriod(false);
    setIsFilterActiveExpectedCtc(false);
    setIsFilterActiveExpectedCtctype(false);
    setIsFilterActiveFname(false);
    setIsFilterActiveLname(false);
    setIsFilterActiveJobt(false);
    setIsFilterActiveStatus(false);
    setIsFilterActiveClient(false);
    setIsFilterActiveOwner(false);
    setIsFilterActiveCtctype(false);
    setIsFilterActiveCtc(false);
    setIsFilterActiveCity(false);
    setIsFilterActiveState(false);
    setIsFilterActiveDate(false);
    setPage(0)
    // getAllSubmissiondata(page, rowsPerPage, moduleData);
    handleFilterAllFieldStep("", 0, rowsPerPage, moduleData);
  };

  const fetchModuleData = async () => {
    try {
      // setIsLoading(true);
      const response =
        userRole != "Admin"
          ? await axios.get(
            `${config.apiUrl}/api/getpermissions/${cookie.role}`
          )
          : {};
      const modules = response.data.modules;
      const JobModule = modules.find((item) => item.module === "Jobs");
      const candidateModule = modules.find(
        (item) => item.module === "candidate"
      );
      const submissionModule = modules.find(
        (item) => item.module === "submission"
      );
      submissionModule &&
        (await handleFilterAllFieldStep(
          "",
          page,
          rowsPerPage,
          submissionModule.permissions
        ));
      if (submissionModule) {
        const permissionsData = submissionModule.permissions;
        setSubmissionModuleData(permissionsData);
      }
      const interviewscheduleModule = modules.find(
        (item) => item.module === "interviewschedule"
      );
      if (interviewscheduleModule) {
        const permissionsData = interviewscheduleModule.permissions;
        setInterviewscheduleModuleData(permissionsData);
      }
      if (candidateModule) {
        const permissionsData = candidateModule.permissions;
        setCandidateModuleData(permissionsData);
      }
      if (JobModule) {
        const permissionsData = JobModule.permissions;
        setModuleData(permissionsData);
      } else {
        console.log("Candidate module not found");
      }
    } catch (error) {
      error && handleFilterAllFieldStep("", page, rowsPerPage);
      console.log("Error while fetching module data:", error);
    }
  };

  useEffect(() => {
    const activityOn = `View ${jobpost?.jobtitle} job `;
    const activityDo = "View Job";
    const component = "jobpost";
    const reData = {
      name: jobpost?.jobtitle,
      id: jobpost?._id,
      action: 'viewJob',
      type: 'job',
      note: null,
    }
    jobpost?.jobtitle &&
      userActivity(
        candidate_ownerName,
        userId,
        component,
        activityDo,
        activityOn,
        userRole,
        reData
      );
  }, [jobpost?.jobtitle]);

  useEffect(() => {
    cookie.role && fetchModuleData();
  }, [cookie.role]);
  useEffect(() => {
    const queryParams = new URLSearchParams();
    if (searchParams.name) queryParams.append("name", searchParams?.name);
    queryParams.append("minScore", searchParams?.minScore);
    queryParams.append("maxScore", searchParams?.maxScore);
    if (searchParams.sortField) queryParams.append("sortField", searchParams?.sortField);
    queryParams.append("sortDirection", searchParams?.sortDirection);
    queryParams.append("page", matchedCandidatePagination.currentPage);
    queryParams.append("limit", matchedCandidatePagination.limit);
    const fetchCandidates = async (page = 1, limit = 10) => {
      try {
        setMatchedCandidateLoading(true);
        setMatchedCandidateError(null);

        const response = await axios.get(
          `${config?.apiUrl}/api/matched_candidate/${id}?${queryParams.toString()}`
        );

        if (response.data.status === "success") {
          setMatchedData(response.data.data);
          setMatchedCandidatePagination(response.data.pagination);
        } else {
          setMatchedCandidateError(response.data.msg);
        }
      } catch (err) {
        if (err.response.data.status === "success") {
          setMatchedData([]);
          setMatchedCandidatePagination(err.response.data.pagination);
          setMatchedCandidateError(err.response.data.msg);
        }
      } finally {
        setMatchedCandidateLoading(false);
      }
    };

    fetchCandidates(matchedCandidatePagination.currentPage, matchedCandidatePagination.limit);
  }, [jobId, matchedCandidatePagination.currentPage, matchedCandidatePagination.limit, searchParams]);

  const [industries, setIndustries] = useState([]);
  const getIndustryData = async () => {
    try {
      const response = await axios.get(
        `${config?.apiUrl}/api/get_all_industries`
      );
      setIndustries(response?.data);
    } catch (error) {
      console.error("Error fetching industry data:", error);
    }
  };

  useEffect(() => {
    getJobpost(id);
    // getJobSubmissionDetail(jobSubmissionPage, rowsPerJobSubmissionPage ,submissionModuleData);
    getIndustryData();
    getJobActivity(id);
    getalluser();
    getCandidateApplicationStatus();
    getCandidateStatus();
  }, []);
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  return (
    <Box>
      <ToastContainer />
      <Box
        className={isSidebarOpen ? "content_details" : "content_details_nav"}
      >
        <div
          style={{
            width: "auto",
            margin: "5rem 0rem 1rem 0rem",
          }}
        >
          <Flex
            position="relative"
            direction="row"
            align={{ sm: "center" }}
            maxW="auto"
            height="auto"
            mx="auto"
            bg={useColorModeValue("white", "gray.700")}
            shadow={{ sm: "base" }}
            rounded={{ sm: "lg" }}
            padding="20px 20px 20px 20px"
            className="job_box"
          >
            <Box textAlign={{ sm: "center" }} pt="2" className="content_title">
              <Heading
                size="lg"
                fontWeight="extrabold"
                letterSpacing="tight"
                className="title_color"
              >
                {!jobpost?.jobtitle ? "N/A" : jobpost?.jobtitle}
              </Heading>
              <Text style={{ fontWeight: "bold" }}>
                TKJ-{!jobpost?.uniqueJobId ? "N/A" : jobpost?.uniqueJobId}
              </Text>
              <div
                style={{
                  backgroundColor: "rgb(244 247 253)",
                  borderRadius: "5px",
                  marginTop: "7px",
                }}
              >
                <Text color={useColorModeValue("gray.600", "gray.400")}>
                  <i
                    className="fa fa-circle"
                    style={{
                      color: jobpost?.status == "Active" ? "green" : "red",
                      fontSize: "12px",
                    }}
                  ></i>{" "}
                  {!jobpost?.status ? "N/A" : jobpost?.status}
                </Text>
              </div>
            </Box>
            <hr className="horizontal_line" />
            <div>
              <Text color={useColorModeValue("gray.600", "gray.400")}>
                Location :{!jobpost?.city ? "N/A" : jobpost?.city},
              </Text>
              <Text color={useColorModeValue("gray.600", "gray.400")}>
                Positions :
                <span style={{ fontWeight: "bold" }}>
                  {!jobpost?.numberofPosition
                    ? "N/A"
                    : jobpost?.numberofPosition}
                </span>{" "}
                Open,
              </Text>
              <Text color={useColorModeValue("gray.600", "gray.400")}>
                Created On :
                <span style={{ fontWeight: "bold" }}>
                  {!jobpost?.created_at ? "N/A" : jobpost?.created_at}
                </span>
              </Text>
            </div>
            <hr className="horizontal_line" />
            <div>
              <Button
                disabled={
                  jobpost?.status == "Inactive" ||
                  new Date(jobpost.targetdate) < new Date()
                }
                style={{
                  color: "white",
                  border: "1px solid #d7d7d7",
                  fontWeight: "500",
                  letterSpacing: "1px",
                  fontSize: "14px",
                }}
                className="bg_color"
                onClick={() => {
                  handleSearchCandidateShow();
                  setSubmission({
                    ...submission,
                    jobId: jobpost._id,
                    Questions: jobpost.question,
                    clientId: jobpost?.clientId?._id,
                    clientemail: jobpost?.clientId?.email,
                    skill: jobpost?.skill,
                    submitterName: jobpost?.clientContactName,
                  });
                  setId("");
                }}
              >
                Submit Candidate
              </Button>
            </div>
          </Flex>
        </div>
        <Tabs
          style={{
            width: "100%",
          }}
          variant="enclosed"
          defaultIndex={iParam ? Number(iParam) : 1}
        >
          <TabList style={{ flexWrap: "wrap" }}>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Overview
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Info
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Submission ({displayAppliedJob?.totalSubmissionCount || 0})
            </Tab>
            {/* <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Interviews (
              {interviewedCandidates?.totalInterviewScheduleCount || 0})
            </Tab> */}
            {/* <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Recruiter Actions
            </Tab> */}
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Activities
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Find Profile LinkedIn
            </Tab>
            <Tab _selected={{ color: "white", bg: "var(--main-bg-color)" }}>
              Matched Candidate's (
              {matchedCandidatePagination?.totalDocuments || 0})
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Row>
                <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                  <div
                    style={{
                      backgroundColor: "#e3ebf8",
                      padding: "30px",
                      width: "auto",
                      height: "100%",
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                    }}
                  >
                    <div class="container">
                      <div
                        className="row"
                        style={{ gap: "23px", height: "auto" }}
                      >
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Pipelined
                          </Text>
                          <Link
                            to={`/admin/total_Pipelined?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {pipelinedCandidates?.length}
                            </Heading>
                          </Link>
                        </div>
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Submitted
                          </Text>
                          <Link
                            to={`/admin/total_Submitted?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {appliedJob?.length}
                            </Heading>
                          </Link>
                        </div>
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Interviewed
                          </Text>
                          <Link
                            to={`/admin/total_Interviewed?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {interviewedCandidates?.length}
                            </Heading>
                          </Link>
                        </div>
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Selected
                          </Text>
                          <Link
                            to={`/admin/total_SelectedCandidates?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {selectedCandidates?.length}
                            </Heading>
                          </Link>
                        </div>
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Accepted
                          </Text>
                          <Link
                            to={`/admin/total_JoinedCandidates?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {acceptedCandidates?.length}
                            </Heading>
                          </Link>
                        </div>
                        <div
                          className="col-sm"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            paddingBottom: "16px",
                            backgroundColor: "white",
                            boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                            borderRadius: "8px",
                          }}
                        >
                          <Text fontSize="lg" color="muted">
                            Onboarded
                          </Text>
                          <Link
                            to={`/admin/total_OnboardedCandidates?id=${id}&type=jobsub`}
                          >
                            <Heading
                              style={{
                                display: "flex",
                                fontSize: "23px",
                                padding: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {onboardedCandidates?.length}
                            </Heading>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                  <div
                    style={{
                      backgroundColor: "#e3ebf8",
                      padding: "30px",
                      width: "auto",
                      height: "100%",
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
                    }}
                  >
                    <Heading
                      style={{
                        fontSize: "20px",
                        marginBottom: "15px",
                      }}
                      className="title_color"
                    >
                      To-Do
                    </Heading>
                    <UnorderedList>
                      <ListItem>0 Tasks pending</ListItem>
                      <ListItem>
                        {interviewedCandidates?.length} Interviews scheduled
                      </ListItem>
                      <ListItem>
                        {onboardingprogressCandidates?.length} Candidates
                        onboarding in progress
                      </ListItem>
                      <ListItem>
                        {pipelinedCandidates?.length} Candidates in pipeline
                      </ListItem>
                    </UnorderedList>
                  </div>
                </Col>
              </Row>
            </TabPanel>
            <TabPanel>
              <Card style={{ width: "100%", marginBottom: "2rem" }}>
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Job Details
                </Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ textAlign: "left" }}>
                    <Container style={{ minWidth: "100%" }}>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Job Title
                          </Text>
                          <span>
                            {!jobpost?.jobtitle ? "N/A" : jobpost?.jobtitle}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Status
                          </Text>
                          <span>
                            {!jobpost?.status ? "N/A" : jobpost?.status}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Work Experience
                          </Text>
                          <span>
                            {!jobpost?.experience ? "N/A" : jobpost?.experience}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Primary Skills
                          </Text>
                          <span>
                            {!jobpost?.skill ? "N/A" : jobpost?.skill}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Job Type
                          </Text>
                          <span>
                            {!jobpost?.jobtype ? "N/A" : jobpost?.jobtype}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Remote Status
                          </Text>
                          <span>
                            {!jobpost?.remotestatus
                              ? "N/A"
                              : jobpost?.remotestatus}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Country
                          </Text>
                          <span>
                            {!jobpost?.country ? "N/A" : jobpost?.country}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            State
                          </Text>
                          <span>
                            {!jobpost?.state ? "N/A" : jobpost?.state}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            City
                          </Text>
                          <span>{!jobpost?.city ? "N/A" : jobpost?.city}</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Client
                          </Text>
                          <span>
                            {!jobpost?.clientId?.accountName
                              ? "N/A"
                              : jobpost?.clientId?.accountName}{" "}
                            {cookie.role !== "Recruiter" && (
                              <Link
                                to={`/details/accountview/${jobpost?.clientId?._id}`}
                                target="_blank"
                              >
                                <VisibilityIcon
                                  style={{
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    color: "grey",
                                  }}
                                />
                              </Link>
                            )}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Client Contact Name
                          </Text>
                          <span>
                            {!jobpost?.clientContactName_data
                              ? "N/A"
                              : jobpost?.clientContactName_data
                                ?.accountOwnerName}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Target Date
                          </Text>
                          <span>
                            {!jobpost?.targetdate ? "N/A" : jobpost?.targetdate}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Industry
                          </Text>
                          <span>
                            {!jobpost?.industry ? "N/A" : jobpost?.industry}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
              <Card style={{ width: "100%", marginBottom: "2rem" }}>
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Recruitment Team
                </Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ textAlign: "left" }}>
                    <Container style={{ minWidth: "100%" }}>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Recruiters
                          </Text>
                          <span>
                            {!jobpost?.recruiter_data
                              ? "N/A"
                              : `${jobpost?.recruiter_data?.firstName} ${jobpost?.recruiter_data?.lastName}`}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Team Leaders
                          </Text>
                          <span>
                            {!jobpost?.teamleader_data
                              ? "N/A"
                              : `${jobpost?.teamleader_data?.firstName} ${jobpost?.teamleader_data?.lastName}`}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Account Manager
                          </Text>
                          <span>
                            {!jobpost?.account_manager_data
                              ? "N/A"
                              : `${jobpost?.account_manager_data?.firstName} ${jobpost?.account_manager_data?.lastName}`}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Interview Panel
                          </Text>
                          <span>
                            {!jobpost?.recruiter_data
                              ? "N/A"
                              : `${jobpost?.recruiter_data?.firstName} ${jobpost?.recruiter_data?.lastName}`}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
              <Card style={{ width: "100%", marginBottom: "2rem" }}>
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Job Description
                </Card.Header>
                <Container style={{ minWidth: "100%" }}>
                  <ListGroup variant="flush">
                    <ListGroup.Item style={{ textAlign: "left" }}>
                      {jobpost?.jobdescription ? (
                        <pre style={{ margin: "0", fontSize: "15px" }}>
                          {jobpost.jobdescription}
                        </pre>
                      ) : (
                        <p>-</p>
                      )}
                    </ListGroup.Item>
                  </ListGroup>
                </Container>
              </Card>
              <Card
                style={{ width: "100%", marginBottom: "2rem" }}
                key={jobpost?.ctc}
              >
                <Card.Header style={{ textAlign: "left", fontWeight: "bold" }}>
                  Salary Details
                </Card.Header>
                <ListGroup variant="flush">
                  <ListGroup.Item style={{ textAlign: "left" }}>
                    <Container style={{ minWidth: "100%" }}>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Placement Type
                          </Text>
                          <span>
                            {!jobpost?.placementType
                              ? "N/A"
                              : jobpost?.placementType}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            Client Pay Type
                          </Text>
                          <span>
                            {" "}
                            {!jobpost?.clientpayType
                              ? "N/A"
                              : jobpost?.clientpayType}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            CTC
                          </Text>
                          <span>{!jobpost?.ctc ? "N/A" : jobpost?.ctc}</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            One Time Placement Bill Type
                          </Text>
                          <span>
                            {!jobpost?.onetimeplacementbillType
                              ? "N/A"
                              : jobpost?.onetimeplacementbillType}
                          </span>
                        </Col>
                        <Col
                          lg={4}
                          md={6}
                          sm={4}
                          style={{ marginBottom: "1rem" }}
                        >
                          <Text
                            color={useColorModeValue("gray.600", "gray.400")}
                            style={{ fontWeight: "bold" }}
                          >
                            One Time Placement Bill Value
                          </Text>
                          <span>
                            {!jobpost?.onetimeplacementbillValue
                              ? "N/A"
                              : jobpost?.onetimeplacementbillValue}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
              <Box className="btns_box">
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "1rem",
                  }}
                >
                  <Button
                    // disabled={
                    //   (moduleData && moduleData.edit == "none") ||
                    //   (moduleData?.edit == "ownrecords" &&
                    //     jobpost?.job_ownerName !==
                    //       localStorage.getItem("candidate_ownerName"))
                    // }
                    className="candi_btns"
                    onClick={() => {
                      handleEditJobShow(setJobId(jobpost?._id));
                      getjob(jobpost);
                    }}
                  >
                    Edit
                  </Button>
                </Box>
              </Box>
              {/* Modal for Edit Job post */}
              <JobAddModal
                setJdLoading={setJdLoading}
                setRecruiters={setRecruiters}
                setSelectedAccountManager={setSelectedAccountManager}
                setSelectedRecruiter={setSelectedRecruiter}
                setSelectedTeamLeader={setSelectedTeamLeader}
                setSelectedTeamD={setSelectedTeamD}
                setJobpost={setJobpost}
                jobBranch={jobBranch}
                setJobBranch={setJobBranch}
                jdLoading={jdLoading}
                getCurrentLoggedInUserName={getCurrentLoggedInUserName}
                industries={industries}
                recruiters={recruiters}
                selectedRecruiter={selectedRecruiter}
                selectedTeamD={selectedTeamD}
                selectedTeamLeader={selectedTeamLeader}
                alluserTeams={alluserTeams}
                selectedAccountManager={selectedAccountManager}
                selectedCity={selectedCity}
                City={City}
                selectedState={selectedState}
                selectedCountry={selectedCountry}
                handleInputs={handleInputs}
                jobpost={jobpost}
                contacts={contacts}
                setSelectedState={setSelectedState}
                setSelectedCity={setSelectedCity}
                setSelectedCountry={setSelectedCountry}
                setSelectedClientContactName={setSelectedClientContactName}
                selectedClientContactName={selectedClientContactName}
                handleChange={handleChange}
                options={options}
                selectedOption={selectedOption}
                //  formSubmitLoading={formSubmitLoading}
                jobLoading={jobLoading}
                ViewPost={ViewEditJob}
                handlePostClose={handleEditJobClose}
                formik={editjobFormik}
                edit={true}
              />
            </TabPanel>
            <TabPanel>
              <CommonSubmissionFile
                isJobDisable={
                  jobpost?.status !== "Active" ||
                  new Date(jobpost.targetdate) < new Date()
                }
                setIsFilterActiveBranch={setIsFilterActiveBranch}
                isFilterActiveBranch={isFilterActiveBranch}
                setSearchBranch={setSearchBranch}
                searchBranch={searchBranch}
                setActivityStatus={setActivityStatus}
                isFilterActiveSubmissionId={isFilterActiveSubmissionId}
                searchSubmissionId={searchSubmissionId}
                setSearchSubmissionId={setSearchSubmissionId}
                setIsFilterActiveNoticePeriod={setIsFilterActiveNoticePeriod}
                setIsFilterActiveUpdatedBy={setIsFilterActiveUpdatedBy}
                setIsFilterActiveSourceSearch={setIsFilterActiveSourceSearch}
                setIsFilterActiveIndustry={setIsFilterActiveIndustry}
                setIsFilterActiveState={setIsFilterActiveState}
                setIsFilterActiveCity={setIsFilterActiveCity}
                setIsFilterActiveClient={setIsFilterActiveClient}
                setIsFilterActiveOwner={setIsFilterActiveOwner}
                setIsFilterActiveStatus={setIsFilterActiveStatus}
                setDisplaySubmissions={setDisplayAppliedJob}
                displaysubmissions={displayAppliedJob}
                Searchicon={Searchicon}
                setIsFilterActiveExperience={setIsFilterActiveExperience}
                searchAllfields={searchAllSubmissionfields}
                setSearchAllfields={setSearchAllSubmissionfields}
                moduleData={submissionModuleData}
                handleCreateSubmission={handleSearchCandidateShow}
                setId={setId}
                handleSubmHeaderOrdersshow={handleSubmHeaderOrdersshow}
                SetIschecked={SetIschecked}
                handleSendMailShow={handleSendMailShow}
                handleOpenModal={handleOpenModal}
                checked={checked}
                handleEditShow={handleEditSubmissionShow}
                setSubmission={setSubmission}
                handleDeleteSubmissionShow={handleRemoveSubmissionShow}
                handleCandidateNoteShow={handleCandidateNoteShow}
                getCandidatNotes={getCandidatNotes}
                SubmissionPreview={SubmissionPreview}
                handleSubmissionPreviewShow={handleSubmissionPreviewShow}
                handleEditSubmissionStatusShow={handleEditSubmissionStatusShow}
                // setChangeStatus={setChangeStatus}
                setOldJobId={setOldJobId}
                page={jobSubmissionPage}
                rowsPerPage={rowsPerJobSubmissionPage}
                applicationStatus={applicationStatus}
                loading={submissionLoading}
                setLoading={setSubmissionLoading}
                // changeStatus={changeStatus}
                setNote={setNote}
                note={note}
                submheaderOrders={submheaderOrders}
                submissions={appliedJob}
                setPage={setJobSubmissionPage}
                setRowsPerPage={setRowsPerJobSubmissionPage}
                componentName={"all"}
                setSubmissionId={setSubmissionId}
                clientId={jobpost?.clientId?.accountName}
                contactId={jobpost?.clientContactName}
                jobId={jobpost?.jobtitle}
                teamData={teamData}
                isClientView={true}
                Setcandidatename={Setcandidatename}
                setActiveField={setActiveField}
                activeField={activeField}
                clearFilter={clearFilter}
                searchfname={searchfname}
                setSearchFname={setSearchFname}
                searchlname={searchlname}
                setSearchLname={setSearchLname}
                searchjobt={searchjobt}
                setSearchJobt={setSearchJobt}
                searchstatus={searchstatus}
                setSearchStatus={setSearchStatus}
                searchcustomer={searchcustomer}
                setSearchCustomer={setSearchCustomer}
                searchOwnerName={searchOwnerName}
                setSearchOwnerName={setSearchOwnerName}
                searchcandidatectctype={searchcandidatectctype}
                setSearchCandidatectctype={setSearchCandidatectctype}
                searchcandidatectc={searchcandidatectc}
                setSearchCandidatectc={setSearchCandidatectc}
                searchcity={searchcity}
                setSearchCity={setSearchCity}
                searchstate={searchstate}
                setSearchstate={setSearchstate}
                searchSubmissionDate={searchSubmissionDate}
                setSearchSubmissionDate={setSearchSubmissionDate}
                searchSubmissionUpdateDate={searchSubmissionUpdateDate}
                setSearchSubmissionUpdateDate={setSearchSubmissionUpdateDate}
                searchExpectedCandidateCTC={searchExpectedCandidateCTC}
                setSearchExpectedCandidateCTC={setSearchExpectedCandidateCTC}
                searchExpectedCandidateCTCType={searchExpectedCandidateCTCType}
                setSearchExpectedCandidateCTCType={
                  setSearchExpectedCandidateCTCType
                }
                searchNoticePeriod={searchNoticePeriod}
                setSearchNoticePeriod={setSearchNoticePeriod}
                searchPhone={searchPhone}
                setSearchPhone={setSearchPhone}
                searchAddress={searchAddress}
                setSearchAddress={setSearchAddress}
                searchDOB={searchDOB}
                setSearchDOB={setSearchDOB}
                searchAadharCardNumber={searchAadharCardNumber}
                setSearchAadharCardNumber={setSearchAadharCardNumber}
                searchPanCardNumber={searchPanCardNumber}
                setSearchPanCardNumber={setSearchPanCardNumber}
                searchDesignation={searchDesignation}
                setSearchDesignation={setSearchDesignation}
                searchWorkExperience={searchWorkExperience}
                setSearchWorkExperience={setSearchWorkExperience}
                searchEducationDetails={searchEducationDetails}
                setSearchEducationDetails={setSearchEducationDetails}
                searchExperience={searchExperience}
                setSearchExperience={setSearchExperience}
                searchGender={searchGender}
                setSearchGender={setSearchGender}
                searchInterviewScheduleDate={searchInterviewScheduleDate}
                setSearchInterviewScheduleDate={setSearchInterviewScheduleDate}
                searchInterviewScheduleTime={searchInterviewScheduleTime}
                setSearchInterviewScheduleTime={setSearchInterviewScheduleTime}
                searchInterviewScheduleLocation={
                  searchInterviewScheduleLocation
                }
                setSearchInterviewScheduleLocation={
                  setSearchInterviewScheduleLocation
                }
                searchInterviewScheduleLink={searchInterviewScheduleLink}
                setSearchInterviewScheduleLink={setSearchInterviewScheduleLink}
                searchJoinDate={searchJoinDate}
                setSearchJoinDate={setSearchJoinDate}
                searchSubmissionBy={searchSubmissionBy}
                setSearchSubmissionBy={setSearchSubmissionBy}
                searchEmail={searchEmail}
                setSearchEmail={setSearchEmail}
                searchContactName={searchContactName}
                setSearchContactName={setSearchContactName}
                searchActualCTC={searchActualCTC}
                setSearchActualCTC={setSearchActualCTC}
                searchOfferCTC={searchOfferCTC}
                setSearchOfferCTC={setSearchOfferCTC}
                searchExpectedJoinDate={searchExpectedJoinDate}
                setSearchExpectedJoinDate={setSearchExpectedJoinDate}
                searchUpdatedBy={searchUpdatedBy}
                setSearchUpdatedBy={setSearchUpdatedBy}
                searchFullName={searchFullName}
                setSearchFullName={setSearchFullName}
                isFilterActiveFname={isFilterActiveFname}
                isFilterActiveFullName={isFilterActiveFullName}
                isFilterActiveUpdatedBy={isFilterActiveUpdatedBy}
                isFilterActiveExpectedJoinDate={isFilterActiveExpectedJoinDate}
                isFilterActiveUpdatedDate={isFilterActiveUpdatedDate}
                isFilterActiveOfferCTC={isFilterActiveOfferCTC}
                isFilterActiveActualCTC={isFilterActiveActualCTC}
                isFilterActiveEmail={isFilterActiveEmail}
                isFilterActiveSubmissionBy={isFilterActiveSubmissionBy}
                isFilterActiveJoinDate={isFilterActiveJoinDate}
                isFilterActiveInterviewScheduleLink={
                  isFilterActiveInterviewScheduleLink
                }
                isFilterActiveInterviewScheduleLocation={
                  isFilterActiveInterviewScheduleLocation
                }
                isFilterActiveInterviewScheduleTime={
                  isFilterActiveInterviewScheduleTime
                }
                isFilterActiveInterviewScheduleDate={
                  isFilterActiveInterviewScheduleDate
                }
                isFilterActiveGender={isFilterActiveGender}
                isFilterActiveExperience={isFilterActiveExperience}
                isFilterActiveEducationDetails={isFilterActiveEducationDetails}
                isFilterActiveWorkExperience={isFilterActiveWorkExperience}
                isFilterActiveDesignation={isFilterActiveDesignation}
                isFilterActivePanCardNumber={isFilterActivePanCardNumber}
                isFilterActiveAadharCardNumber={isFilterActiveAadharCardNumber}
                isFilterActiveDOB={isFilterActiveDOB}
                isFilterActiveAddress={isFilterActiveAddress}
                isFilterActivePhone={isFilterActivePhone}
                isFilterActiveNoticePeriod={isFilterActiveNoticePeriod}
                isFilterActivEexpectedCtctype={isFilterActivEexpectedCtctype}
                isFilterActiveExpectedCtc={isFilterActiveExpectedCtc}
                isFilterActiveLname={isFilterActiveLname}
                isFilterActiveJobt={isFilterActiveJobt}
                isFilterActiveStatus={isFilterActiveStatus}
                isFilterActiveClient={isFilterActiveClient}
                isFilterActiveOwner={isFilterActiveOwner}
                isFilterActiveCtctype={isFilterActiveCtctype}
                isFilterActiveCtc={isFilterActiveCtc}
                isFilterActiveCity={isFilterActiveCity}
                isFilterActiveState={isFilterActiveState}
                isFilterActiveDate={isFilterActiveDate}
                isFilterActiveContactName={isFilterActiveContactName}
                setIsFilterActiveSubmissionBy={setIsFilterActiveSubmissionBy}
                filterData={filterData}
                setMySubmissionValue={setMySubmissionValue}
                mySubmissionValue={mySubmissionValue}
                handleFilterAllFieldStep={handleFilterAllFieldStep}
                popoverVisible={popoverVisible}
                setPopoverVisible={setPopoverVisible}
                handlePopOverClose={handlePopOverClose}
                industries={industries}
                setSearchIndustry={setSearchIndustry}
                searchIndustry={searchIndustry}
                isFilterActiveIndustry={isFilterActiveIndustry}
                handleActivitySubmit={handleCandidateActivitySubmit}
                searchInterviewRescheduleDate={searchInterviewRescheduleDate}
                setSearchInterviewRescheduleDate={
                  setSearchInterviewRescheduleDate
                }
                isFilterActiveInterviewRescheduleDate={
                  isFilterActiveInterviewRescheduleDate
                }
                searchTestRescheduleDate={searchTestRescheduleDate}
                setSearchTestRescheduleDate={setSearchTestRescheduleDate}
                isFilterActiveTestRescheduleDate={
                  isFilterActiveTestRescheduleDate
                }
                searchBackoutDate={searchBackoutDate}
                setSearchBackoutDate={setSearchBackoutDate}
                isFilterActiveBackoutDate={isFilterActiveBackoutDate}
                setSearchSourceData={setSearchSourceData}
                searchSourceData={searchSourceData}
                isFilterActiveSourceSearch={isFilterActiveSourceSearch}
              />
              <CustomizeColumns
                ViewSubmheaderOrders={ViewSubmheaderOrders}
                handleSubmHeaderOrdersClose={handleSubmHeaderOrdersClose}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={handleApplyClick}
              />

              {/* Modal for Candidate Note creation */}
              <NoteSubmissionModel
                candidateNote={candidateNote}
                handleCandidateNoteClose={handleCandidateNoteClose}
                searchNote={searchNote}
                getnotes={getnotes}
                setSearchNote={setSearchNote}
                setNote={setNote}
                note={note}
                setGetNotes={setGetNotes}
                // getJobpostdata={getJobSubmissionDetail}
                getJobpostdata={handleFilterAllFieldStep}
                page={page}
                rowsPerPage={rowsPerPage}
                moduleData={submissionModuleData}
                setNotesLoading={setNotesLoading}
                notesLoading={notesLoading}
              />

              <CustomizeColumns
                ViewSubmheaderOrders={isOpen}
                handleSubmHeaderOrdersClose={handleCloseModal}
                onDragEnd={onDragEnd}
                displaySubmheaderOrders={displaySubmheaderOrders}
                defaultDisplaySubmHeaderOrders={defaultDisplaySubmHeaderOrders}
                handleCheckboxChange={handleCheckboxChange}
                handleApplyClick={exportSubmissions}
                candidates={displayAppliedJob}
                filename={filename}
                Changeoption={handleApplyClick}
              />

              {/* Modal for Delete Submission */}
              <DeleteModal
                ViewDelete={removeSubmission}
                title={"Delete Submission"}
                handleDeleteClose={handleRemoveSubmissionClose}
                handleDelete={handleDeleteSubmission}
              />
              {/* Modal for Batch Send Email*/}
              <ComposeMailForm
                ViewSendMail={ViewSendMail}
                handleSendMailClose={handleSendMailClose}
                SetToemail={SetToemail}
                SetCcemail={SetCcemail}
                SetBccemail={SetBccemail}
                SetSubject={SetSubject}
                SetMailMessage={SetMailMessage}
                checked={checked}
                endPoint={"/api/SelectCandidate_EmailSend"}
              />

              {/* Modal for Edit Submission Status*/}

              <EditSubmissionStatusModel
                editSubmissionStatus={editSubmissionStatus}
                handleEditSubmissionStatusClose={
                  handleEditSubmissionStatusClose
                }
                submission={submission}
                handleInputs={handleSubmInputs}
                applicationStatus={applicationStatus}
                handleUpdateStatus={handleEditSubmissionStatus}
                handleEditShow={handleEditSubmissionShow}
                SetEditSubmissionStatus={SetEditSubmissionStatus}
              />

              {/* Modal for Submission Preview */}
              <ResumePreviewModal
                preview={submissionPreview}
                handlePreviewClose={handleSubmissionPreviewClose}
                objectURL={objectURL?.filePath}
                firstName={submission?.candidateId?.firstName}
                lastName={submission?.candidateId?.lastName}
                phone={submission?.candidateId?.phone}
                email={submission?.candidateId?.email}
                fileName={submission?.fileName}
                resumeFilePath={""}
                action={() => {
                  () => {
                    handleCandidateNoteShow();
                    setNote({
                      ...note,
                      candidateId: submission?.candidateId?._id,
                    });
                    getCandidatNotes(submission?.candidateId?._id);
                  };
                }}
              />
              {/* <div className="model-box-view">
                <Modal
                  show={submissionPreview}
                  onHide={handleSubmissionPreviewClose}
                  backdrop="static"
                  keyboard={false}
                  size="xl"
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="usertitle">
                      Resume Preview
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={8} md={6} sm={6}>
                        {!objectURL ? (
                          <>
                            <div className="resume_ld">
                              <Loader />
                            </div>
                          </>
                        ) : objectURL === "no-resume" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                            }}
                          >
                            <img
                              src={NotFound}
                              alt="NotFound"
                              style={{ width: "16rem" }}
                            />
                            <p>No Resume Found! Please try again....</p>
                          </div>
                        ) : (
                          <div
                            style={{
                              borderRight: "1px solid rgb(222, 226, 230)",
                              paddingRight: "18px",
                            }}
                          >
                            {(() => {
                              const isObjectUrlDoc =
                                objectURL &&
                                (objectURL?.filePath
                                  .toLowerCase()
                                  .endsWith(".doc") ||
                                  objectURL?.filePath
                                    .toLowerCase()
                                    .endsWith(".docx"));
                              if (isObjectUrlDoc) {
                                const filePath = objectURL
                                  ? `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                  : resumeFilePath;

                                return (
                                  <>
                                    <Box
                                      style={{
                                        overflow: "auto",
                                        userSelect: "text",
                                        height: "85vh",
                                        position: "relative",
                                      }}
                                    >
                                      <FileViewer
                                        fileType={
                                          objectURL?.filePath
                                            .toLowerCase()
                                            .endsWith(".doc")
                                            ? "doc"
                                            : "docx"
                                        }
                                        filePath={filePath}
                                        onError={(e) => {
                                          console.error("FileViewer Error:", e);
                                          // setViewerError(e);
                                        }}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                    </Box>
                                  </>
                                );
                              }

                              // Use iframe for other file types
                              return (
                                <>
                                  {objectURL && (
                                    <iframe
                                      src={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`}
                                      width="100%"
                                      height="800px"
                                      title="PDF Viewer"
                                      frameBorder="0"
                                      style={{ border: "none" }}
                                    />
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        )}
                      </Col>
                      <Col lg={4} md={6} sm={6}>
                        <div className="resume_pr">
                          <div>
                            <Button
                              className="bg_color"
                              style={{
                                color: "white",
                                border: "1px solid #d7d7d7",
                                fontWeight: "500",
                                letterSpacing: "1px",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                handleCandidateNoteShow();
                                setNote({
                                  ...note,
                                  candidateId: submission?.candidateId?._id,
                                });
                                getCandidatNotes(submission?.candidateId?._id);
                              }}
                            >
                              Notes
                            </Button>
                            <Heading
                              size="md"
                              fontWeight="bold"
                              letterSpacing="tight"
                            >
                              {!submission?.candidateId?.firstName
                                ? "N/A"
                                : submission?.candidateId?.firstName}{" "}
                              {!submission?.candidateId?.lastName
                                ? "N/A"
                                : submission?.candidateId?.lastName}
                            </Heading>
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                            >
                              <CallOutlinedIcon
                                style={{ fontSize: "medium" }}
                              />{" "}
                              {!submission?.candidateId?.phone
                                ? "N/A"
                                : submission?.candidateId?.phone}
                            </Text>
                            <Text
                              color={useColorModeValue("gray.600", "gray.400")}
                            >
                              <EmailOutlinedIcon
                                style={{ fontSize: "medium" }}
                              />{" "}
                              {!submission?.candidateId?.email
                                ? "N/A"
                                : submission?.candidateId?.email}
                            </Text>
                          </div>
                          <div>
                            <Tooltip
                              hasArrow
                              label="Download Resume"
                              bg="gray.300"
                              color="black"
                            >
                              <a
                                href={
                                  objectURL === "no-resume"
                                    ? "#"
                                    : `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                }
                                download={`https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`}
                                onClick={(e) => {
                                  if (
                                    objectURL?.filePath
                                      .toLowerCase()
                                      .endsWith(".pdf")
                                  ) {
                                    e.preventDefault();
                                    fetch(
                                      `https://ats-tekpillar.blr1.digitaloceanspaces.com/${objectURL?.filePath}`
                                    )
                                      .then((response) => response.blob())
                                      .then((blob) => {
                                        const url =
                                          window.URL.createObjectURL(blob);
                                        const link =
                                          document.createElement("a");
                                        link.href = url;
                                        link.download =
                                          objectURL?.filePath
                                            .split("/")
                                            .pop() || "download.pdf";
                                        document.body.appendChild(link);
                                        link.click();
                                        link.remove();
                                        window.URL.revokeObjectURL(url);
                                      });
                                  }
                                }}
                                rel="noopener noreferrer"
                              >
                                <button
                                  class="btn bg-white border rounded mb-2 text-break"
                                  style={{ width: "100%", height: "auto" }}
                                >
                                  {!submission?.fileName
                                    ? "N/A"
                                    : submission?.fileName}{" "}
                                  <VerticalAlignBottomIcon
                                    style={{ color: "grey" }}
                                  />
                                </button>
                              </a>
                            </Tooltip>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="cancel"
                      onClick={handleSubmissionPreviewClose}
                    >
                      Cancel
                    </button>
                  </Modal.Footer>
                </Modal>
              </div> */}
            </TabPanel>
            {/* <TabPanel>
              <CommonSubmissionFile
                getAllSubmissiondata={getJobSubmissionDetail}
                setDisplaySubmissions={setDisplayInterviewedCandidates}
                displaysubmissions={displayinterviewedCandidates}
                Searchicon={Searchicon}
                searchAllfields={searchAllSubmissionfields}
                setSearchAllfields={setSearchAllSubmissionfields}
                moduleData={interviewscheduleModuleData}
                handleCreateSubmission={handleSearchCandidateShow}
                setId={setId}
                handleSubmHeaderOrdersshow={handleSubmHeaderOrdersshow}
                SetIschecked={SetIschecked}
                handleSendMailShow={handleSendMailShow}
                handleOpenModal={handleOpenModal}
                checked={checked}
                handleEditShow={handleEditSubmissionShow}
                setSubmission={setSubmission}
                handleDeleteSubmissionShow={handleRemoveSubmissionShow}
                handleCandidateNoteShow={handleCandidateNoteShow}
                getCandidatNotes={getCandidatNotes}
                SubmissionPreview={SubmissionPreview}
                handleSubmissionPreviewShow={handleSubmissionPreviewShow}
                handleEditSubmissionStatusShow={handleEditSubmissionStatusShow}
                // setChangeStatus={setChangeStatus}
                setOldJobId={setOldJobId}
                page={jobSubmissionPage}
                rowsPerPage={rowsPerJobSubmissionPage}
                applicationStatus={applicationStatus}
                loading={submissionLoading}
                setLoading={setSubmissionLoading}
                // changeStatus={changeStatus}
                setNote={setNote}
                note={note}
                submheaderOrders={submheaderOrders}
                submissions={interviewedCandidates}
                setPage={setJobSubmissionPage}
                setRowsPerPage={setRowsPerJobSubmissionPage}
                componentName={"all"}
                setSubmissionId={setSubmissionId}
                isClientView={true}
                clientId={jobpost?.clientId?.accountName}
                contactId={jobpost?.clientContactName}
                jobId={jobpost?.jobtitle}
                Setcandidatename={Setcandidatename}
                teamData={teamData}
                setActiveField={setActiveField}
                activeField={activeField}
                clearFilter={clearFilter}
                searchfname={searchfname}
                setSearchFname={setSearchFname}
                searchlname={searchlname}
                setSearchLname={setSearchLname}
                searchjobt={searchjobt}
                setSearchJobt={setSearchJobt}
                searchstatus={searchstatus}
                setSearchStatus={setSearchStatus}
                searchcustomer={searchcustomer}
                setSearchCustomer={setSearchCustomer}
                searchOwnerName={searchOwnerName}
                setSearchOwnerName={setSearchOwnerName}
                searchcandidatectctype={searchcandidatectctype}
                setSearchCandidatectctype={setSearchCandidatectctype}
                searchcandidatectc={searchcandidatectc}
                setSearchCandidatectc={setSearchCandidatectc}
                searchcity={searchcity}
                setSearchCity={setSearchCity}
                searchstate={searchstate}
                setSearchstate={setSearchstate}
                searchSubmissionDate={searchSubmissionDate}
                setSearchSubmissionDate={setSearchSubmissionDate}
                searchSubmissionUpdateDate={searchSubmissionUpdateDate}
                setSearchSubmissionUpdateDate={setSearchSubmissionUpdateDate}
                searchExpectedCandidateCTC={searchExpectedCandidateCTC}
                setSearchExpectedCandidateCTC={setSearchExpectedCandidateCTC}
                searchExpectedCandidateCTCType={searchExpectedCandidateCTCType}
                setSearchExpectedCandidateCTCType={
                  setSearchExpectedCandidateCTCType
                }
                searchNoticePeriod={searchNoticePeriod}
                setSearchNoticePeriod={setSearchNoticePeriod}
                searchPhone={searchPhone}
                setSearchPhone={setSearchPhone}
                searchAddress={searchAddress}
                setSearchAddress={setSearchAddress}
                searchDOB={searchDOB}
                setSearchDOB={setSearchDOB}
                searchAadharCardNumber={searchAadharCardNumber}
                setSearchAadharCardNumber={setSearchAadharCardNumber}
                searchPanCardNumber={searchPanCardNumber}
                setSearchPanCardNumber={setSearchPanCardNumber}
                searchDesignation={searchDesignation}
                setSearchDesignation={setSearchDesignation}
                searchWorkExperience={searchWorkExperience}
                setSearchWorkExperience={setSearchWorkExperience}
                searchEducationDetails={searchEducationDetails}
                setSearchEducationDetails={setSearchEducationDetails}
                searchExperience={searchExperience}
                setSearchExperience={setSearchExperience}
                searchGender={searchGender}
                setSearchGender={setSearchGender}
                searchInterviewScheduleDate={searchInterviewScheduleDate}
                setSearchInterviewScheduleDate={setSearchInterviewScheduleDate}
                searchInterviewScheduleTime={searchInterviewScheduleTime}
                setSearchInterviewScheduleTime={setSearchInterviewScheduleTime}
                searchInterviewScheduleLocation={
                  searchInterviewScheduleLocation
                }
                setSearchInterviewScheduleLocation={
                  setSearchInterviewScheduleLocation
                }
                searchInterviewScheduleLink={searchInterviewScheduleLink}
                setSearchInterviewScheduleLink={setSearchInterviewScheduleLink}
                searchJoinDate={searchJoinDate}
                setSearchJoinDate={setSearchJoinDate}
                searchSubmissionBy={searchSubmissionBy}
                setSearchSubmissionBy={setSearchSubmissionBy}
                searchEmail={searchEmail}
                setSearchEmail={setSearchEmail}
                searchContactName={searchContactName}
                setSearchContactName={setSearchContactName}
                searchActualCTC={searchActualCTC}
                setSearchActualCTC={setSearchActualCTC}
                searchOfferCTC={searchOfferCTC}
                setSearchOfferCTC={setSearchOfferCTC}
                searchExpectedJoinDate={searchExpectedJoinDate}
                setSearchExpectedJoinDate={setSearchExpectedJoinDate}
                searchUpdatedBy={searchUpdatedBy}
                setSearchUpdatedBy={setSearchUpdatedBy}
                searchFullName={searchFullName}
                setSearchFullName={setSearchFullName}
                isFilterActiveFname={isFilterActiveFname}
                isFilterActiveFullName={isFilterActiveFullName}
                isFilterActiveUpdatedBy={isFilterActiveUpdatedBy}
                isFilterActiveExpectedJoinDate={isFilterActiveExpectedJoinDate}
                isFilterActiveUpdatedDate={isFilterActiveUpdatedDate}
                isFilterActiveOfferCTC={isFilterActiveOfferCTC}
                isFilterActiveActualCTC={isFilterActiveActualCTC}
                isFilterActiveEmail={isFilterActiveEmail}
                isFilterActiveSubmissionBy={isFilterActiveSubmissionBy}
                isFilterActiveJoinDate={isFilterActiveJoinDate}
                isFilterActiveInterviewScheduleLink={
                  isFilterActiveInterviewScheduleLink
                }
                isFilterActiveInterviewScheduleLocation={
                  isFilterActiveInterviewScheduleLocation
                }
                isFilterActiveInterviewScheduleTime={
                  isFilterActiveInterviewScheduleTime
                }
                isFilterActiveInterviewScheduleDate={
                  isFilterActiveInterviewScheduleDate
                }
                isFilterActiveGender={isFilterActiveGender}
                isFilterActiveExperience={isFilterActiveExperience}
                isFilterActiveEducationDetails={isFilterActiveEducationDetails}
                isFilterActiveWorkExperience={isFilterActiveWorkExperience}
                isFilterActiveDesignation={isFilterActiveDesignation}
                isFilterActivePanCardNumber={isFilterActivePanCardNumber}
                isFilterActiveAadharCardNumber={isFilterActiveAadharCardNumber}
                isFilterActiveDOB={isFilterActiveDOB}
                isFilterActiveAddress={isFilterActiveAddress}
                isFilterActivePhone={isFilterActivePhone}
                isFilterActiveNoticePeriod={isFilterActiveNoticePeriod}
                isFilterActivEexpectedCtctype={isFilterActivEexpectedCtctype}
                isFilterActiveExpectedCtc={isFilterActiveExpectedCtc}
                isFilterActiveLname={isFilterActiveLname}
                isFilterActiveJobt={isFilterActiveJobt}
                isFilterActiveStatus={isFilterActiveStatus}
                isFilterActiveClient={isFilterActiveClient}
                isFilterActiveOwner={isFilterActiveOwner}
                isFilterActiveCtctype={isFilterActiveCtctype}
                isFilterActiveCtc={isFilterActiveCtc}
                isFilterActiveCity={isFilterActiveCity}
                isFilterActiveState={isFilterActiveState}
                isFilterActiveDate={isFilterActiveDate}
                isFilterActiveContactName={isFilterActiveContactName}
                setIsFilterActiveSubmissionBy={setIsFilterActiveSubmissionBy}
                filterData={filterData}
                setMySubmissionValue={setMySubmissionValue}
                mySubmissionValue={mySubmissionValue}
                handleFilterAllFieldStep={handleFilterAllFieldStep}
                popoverVisible={popoverVisibleInterview}
                setPopoverVisible={setPopoverVisibleInterview}
                handlePopOverClose={handlePopOverinterviewClose}
                industries={industries}
                setIsFilterActiveIndustry={setIsFilterActiveIndustry}
                setSearchIndustry={setSearchIndustry}
                searchIndustry={searchIndustry}
                isFilterActiveIndustry={isFilterActiveIndustry}
                handleActivitySubmit={handleCandidateActivitySubmit}
              />
            </TabPanel> */}
            {/* <TabPanel></TabPanel> */}
            <TabPanel>
              {activity?.map((value, index) => (
                <>
                  <MDBContainer>
                    <ul className="timeline">
                      <li className="timeline-item">
                        <h5 className="activitytitle">{value.jobActivity}</h5>
                        {value && value?.submittedById && (
                          <h5 className="activitytitle">
                            By :{" "}
                            {`${value?.submittedById?.firstName} ${value?.submittedById?.lastName}` ||
                              "N/A"}
                          </h5>
                        )}
                        <p className="activityinfo">
                          {
                            new Date(value.created_at)
                              .toLocaleString()
                              ?.split(",")[0]
                          }
                          <br />
                          {
                            new Date(value.created_at)
                              .toLocaleString()
                              ?.split(",")[1]
                          }
                        </p>
                      </li>
                    </ul>
                  </MDBContainer>
                </>
              ))}
            </TabPanel>
            <TabPanel>
              <Box
                style={{
                  width: "auto",
                  height: "auto",
                  backgroundColor: "white",
                  padding: "3rem",
                }}
              >
                <Container>
                  <Text
                    fontSize="3xl"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "1.5rem",
                    }}
                    className="title_color"
                  >
                    Easily use Google to search profiles on LinkedIn
                  </Text>
                  <Row>
                    <Col lg={6} md={6}>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          color: "#000000",
                        }}
                      >
                        Job Title
                      </label>
                      <Input
                        variant="auth"
                        fontSize="m"
                        type="text"
                        placeholder="E.g. accountant OR cfo"
                        mb="24px"
                        size="lg"
                        name="jobtitle"
                        value={displayjobpost?.jobtitle}
                        onChange={handleLinkUpdate}
                        style={{ height: "37px" }}
                      />
                    </Col>
                    <Col lg={6} md={6}>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          color: "#000000",
                        }}
                      >
                        Location or keywords to include
                      </label>
                      <Input
                        variant="auth"
                        fontSize="m"
                        type="text"
                        placeholder="E.g. London OR Paris AND html"
                        mb="24px"
                        size="lg"
                        name="city"
                        value={displayjobpost?.city}
                        onChange={handleLinkUpdate}
                        style={{ height: "37px" }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6}>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          color: "#000000",
                        }}
                      >
                        Skill
                      </label>
                      <Input
                        variant="auth"
                        fontSize="m"
                        type="text"
                        placeholder="E.g. skills"
                        mb="24px"
                        size="lg"
                        name="skill"
                        value={displayjobpost?.skill}
                        onChange={handleLinkUpdate}
                        style={{ height: "37px" }}
                      />
                    </Col>
                    <Col lg={6} md={6}>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          color: "#000000",
                        }}
                      >
                        Current companyname
                      </label>
                      <Input
                        variant="auth"
                        fontSize="m"
                        type="text"
                        placeholder="Current companyname"
                        mb="24px"
                        size="lg"
                        name="currentcompanyname"
                        value={displayjobpost?.currentcompanyname}
                        onChange={handleLinkUpdate}
                        style={{ height: "37px" }}
                      />
                    </Col>
                  </Row>
                  <button
                    className="linkedin_btn"
                    onClick={() => {
                      handlesearchQueryShow();
                      handlelinkedin();
                    }}
                  >
                    Find the right people on LinkedIn
                  </button>
                </Container>
              </Box>
            </TabPanel>
            <TabPanel>
              <MatchedCandidatesTable
                templateData={{
                  jobTitle: jobpost?.jobtitle,
                  jobDescription: jobpost?.jobdescription,
                  jobLocation: jobpost?.city,
                  jobType: jobpost?.jobtype,
                  experience: jobpost?.experience,
                  JobLink: `https://careers.tekpillar.in/jobs/${jobpost?.jobtitle?.replaceAll(
                    " ",
                    "_"
                  )}-${jobpost?.city?.replaceAll(" ", "_")}?jobid=${jobpost?._id}`,
                  companyName: jobpost?.clientId?.accountName,
                  recuiterName: `${jobpost?.recruiter_data?.firstName + " " + jobpost?.recruiter_data?.lastName}`,
                  recuiterPhone: jobpost?.recruiter_data?.phone,
                  job_ownerName_Id: jobpost?.job_ownerName_Id,
                }}
                loading={matchedCandidateLoading}
                matchedData={matchedData}
                totalCount={matchedCandidatePagination.totalDocuments}
                rowsPerPage={matchedCandidatePagination.limit}
                page={matchedCandidatePagination.currentPage}
                handleChangePage={handleChangePageMatchedCandidate}
                handleChangeRowsPerPage={
                  handleChangeRowsPerPageMatchedCandidate
                }
                setSearchParams={setSearchParams}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>

        {/* Modal for Search Query linkedIn*/}
        <Modal
          show={searchQuery}
          onHide={handlesearchQueryClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="usertitle"
            >
              Your Search Query
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Text style={{ marginBottom: "1rem" }}>
              Copy, save or open the search string in Google and find the right
              candidates
            </Text>
            <Row>
              <Col lg={12} md={6}>
                <Input
                  variant="auth"
                  fontSize="sm"
                  type="text"
                  mb="24px"
                  size="lg"
                  name="linkedinUrl"
                  value={linkedinUrl}
                  onChange={handleUrlUpdate}
                  style={{ height: "37px" }}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <button className="cancel" onClick={handlesearchQueryClose}>
              Cancel
            </button>
            <button className="copy_btn" onClick={copyToClipboard}>
              <ContentCopyIcon style={{ fontSize: "20px" }} /> Copy URL
            </button>
            <a href={linkedinUrl} target="__blank">
              <button className="open_In_google_btn">
                <OpenInNewIcon style={{ fontSize: "20px" }} /> Open In Google
              </button>
            </a>
          </Modal.Footer>
        </Modal>

        {/* Modal for Search Candidate */}
        <SearchCandidateModel
          serachCandidateId={uniqueCandidateId}
          setSerachCandidateId={setUniqueCandidateId}
          searchCandidateModelShow={searchCandidateModelShow}
          handleSearchCandidateClose={handleSearchCandidateClose}
          searchcandidate={searchcandidate}
          setSearchcandidate={setSearchcandidate}
          filterCandidateData={filterCandidateData}
          candidateModuleData={candidateModuleData}
          jobpostview={"job"}
          handleCandidateShow={handleCandidateShow}
          parseFile={parseFile}
          loading={searchCandidateLoading}
          candidates={candidates}
          setSubmission={setSubmission}
          submission={submission}
          Setcandidatename={Setcandidatename}
          candidatename={candidatename}
          handleSubmitSubmissionShow={handleSubmitSubmissionShow}
          rowsPerCandidateSubmissionPage={rowsPerCandidateSubmissionPage}
          candidatesubmissionpage={candidatesubmissionpage}
          handleChangeCandidateSubmissionPage={
            handleChangeCandidateSubmissionPage
          }
          handleChangeRowsPerCandidateSubmissionPage={
            handleChangeRowsPerCandidateSubmissionPage
          }
          setSearchCandidateName={setSearchCandidateName}
          searchCandidateName={searchCandidateName}
          setSearchCandidateDesignation={setSearchCandidateDesignation}
          searchCandidateDesignation={searchCandidateDesignation}
          setSearchCandidateCity={setSearchCandidateCity}
          searchCandidateCity={searchCandidateCity}
          setCandidateSearchActiveField={setCandidateSearchActiveField}
          candidateSearchActiveField={candidateSearchActiveField}
          clearCandidateSearchFilter={clearCandidateSearchFilter}
          setSearchCandidateOwnerName={setSearchCandidateOwnerName}
          searchCandidateOwnerName={searchCandidateOwnerName}
        />
        {/* Modal for Edit Submission */}
        {/* Modal for Submit Submission */}

        <Submissionform
          handleInputs={handleSubmInputs}
          saveFile={saveSubmFile}
          setCandidate={setCandidate}
          show={true}
          applicationStatus={applicationStatus}
          candidateStatus={submission?.status}
          // getAllSubmissiondata={getJobSubmissionDetail}
          getAllSubmissiondata={handleFilterAllFieldStep}
          handleSubmitSubmissionClose={handleSubmitSubmissionClose}
          submitSubmission={submitSubmission}
          submission={submission}
          setSubmission={setSubmission}
          handleActivitySubmit={handleActivitySubmit}
          handleCandidateActivitySubmit={handleCandidateActivitySubmit}
          candidatename={candidatename}
          jobtitle={jobtitle}
          handleAppliedJobClientEmailSend={handleAppliedJobClientEmailSend}
          id={resumeid}
          setId={setId}
          handleEditShow={handleEditShow}
          editSubmission={editSubmission}
          handleEditClose={handleEditSubmissionClose}
          handleResumeMatching={handleResumeMatching}
          matchingSkills={matchingSkills}
          ParsedSkills={parsedSkills}
          missingSkills={missingSkills}
          router={router}
          handleAppliedJobEmailSend={handleAppliedJobEmailSend}
          parseResumeConclusion={parseResumeConclusion}
          loadingResumeScreening={loadingResumeScreening}
          parsePercentage={parsePercentage}
          parseAge={parseAge}
          moduleData={submissionModuleData}
          component={"jobpost"}
          page={jobSubmissionPage}
          rowsPerPage={rowsPerJobSubmissionPage}
        />

        {/* Modal for Add Candidate */}
        <Modal
          show={ViewCandidate}
          onHide={handleCandidateClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="usertitle"
            >
              Add Candidate
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              {resumeFilePath && (
                <Col lg={6} md={6}>
                  <div style={{ width: "100%" }}>
                    {/* Dispaly resume after parse resume on left side of form  but when file type is docx it cannot show*/}
                    {resumeFilePath && (
                      <div
                        style={
                          showResumeDetails
                            ? {
                              display: "flex",
                              zIndex: "2000",
                            }
                            : null
                        }
                      >
                        {showResumeDetails && (
                          <ParsedResumeDetails
                            resumeFilePath={resumeFilePath}
                            showResumeDetails={showResumeDetails}
                            toggleResumeDetails={toggleResumeDetails}
                            file={file}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </Col>
              )}
              <Col lg={!resumeFilePath ? 12 : 6} md={6}>
                <form
                  id="addcandidate"
                  className="addcandidatemodelform"
                  onSubmit={formik.handleSubmit}
                >
                  <Container>
                    <div style={{ width: "100%", marginBottom: "1rem" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          fontFamily: "Roboto",
                          color: "#000000",
                        }}
                      >
                        Resume
                      </label>
                      <div class="file-dummy">
                        <div class="default">
                          <span class="drag">Drag and Drop Resume</span>
                          <br />
                          or you can <span class="browse">Browse</span> and find
                          a file here
                        </div>
                        <input
                          type="file"
                          id="candidate-file-input"
                          name="file"
                          onBlur={formik.handleBlur}
                          onChange={(e) => {
                            saveFile(e, "add");
                          }}
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        />
                      </div>
                      <div
                        style={{
                          width: "auto",
                          height: "2rem",
                          border: "1px solid grey",
                          marginTop: "1rem",
                          padding: "4px",
                          paddingLeft: "16px",
                          border:
                            formik.touched.file && formik.errors.file
                              ? "1px solid red"
                              : "1px solid #ccc",
                        }}
                        className="resumename"
                      >
                        {formik.touched.file && formik.errors.file
                          ? formik.errors.file
                          : formik.values.file
                            ? formik.values.file.name
                            : ""}
                      </div>
                    </div>

                    <Row>
                      <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          First Name
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="First Name"
                          size="lg"
                          name="firstName"
                          value={formik.values.firstName}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              firstname: e.target.value,
                            });
                          }}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.firstName &&
                                formik.errors.firstName
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.firstName &&
                          formik.errors.firstName && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.firstName}
                            </div>
                          )}
                      </Col>
                      <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Last Name
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Last Name"
                          size="lg"
                          name="lastName"
                          value={formik.values.lastName}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              lastname: e.target.value,
                            });
                          }}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.lastName && formik.errors.lastName
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.lastName && formik.errors.lastName && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.lastName}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Email
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Email"
                          size="lg"
                          name="email"
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              email: e.target.value,
                            });
                          }}
                          value={formik.values.email}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.email && formik.errors.email
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.email}
                          </div>
                        )}
                      </Col>
                      <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Phone
                        </FormLabel>
                        <div className="candidatephone">
                          <PhoneInput
                            country={"in"}
                            containerStyle={{
                              border:
                                formik.touched.phone && formik.errors.phone
                                  ? "1px solid red"
                                  : "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                            value={formik.values.phone}
                            onChange={(phone) => {
                              const cleanedPhone = phone.replace(/\D/g, "");
                              const formattedPhone = `+${cleanedPhone.slice(
                                0,
                                2
                              )} ${cleanedPhone.slice(2)}`;

                              setCandidate({
                                ...candidate,
                                phone: formattedPhone,
                              });
                              setParsedata({
                                ...parsedata,
                                phone: formattedPhone,
                              });
                              const phoneNumberWithPlus = `+${phone}`;
                              formik.setFieldValue(
                                "phone",
                                phoneNumberWithPlus
                              );
                            }}
                          />
                          {formik.touched.phone && formik.errors.phone && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.phone}
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} style={{ marginBottom: "24px" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Candidate Designation
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="tel"
                          placeholder="Candidate Designation"
                          size="lg"
                          name="designation"
                          value={formik.values.designation}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              designation: e.target.value,
                            });
                          }}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.designation &&
                                formik.errors.designation
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.designation &&
                          formik.errors.designation && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.designation}
                            </div>
                          )}
                      </Col>
                      <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Application Status
                        </FormLabel>
                        <select
                          className="form-control"
                          name="status"
                          disabled
                          value={formik.values.status}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.status && formik.errors.status
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        >
                          <option disabled={true} value="">
                            Application Status
                          </option>
                          {applicationStatus?.map((val) => (
                            <>
                              <option value={val?.CandidateApplicationStatus}>
                                {val?.CandidateApplicationStatus}
                              </option>
                            </>
                          ))}
                        </select>
                        {formik.touched.status && formik.errors.status && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.status}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={4} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Country
                        </FormLabel>
                        <div style={{ width: "100%", height: "37px" }}>
                          <Select
                            options={Country.getAllCountries()}
                            placeholder="Select Country"
                            getOptionLabel={(options) => {
                              return options["name"];
                            }}
                            getOptionValue={(options) => {
                              return options["name"];
                            }}
                            name="country"
                            value={selectedCountry}
                            onChange={(item) => {
                              setSelectedCountry(item);
                              setCandidate({
                                ...candidate,
                                country: item.name,
                              });

                              formik.setFieldValue("country", item.name);
                            }}
                            classNamePrefix={
                              formik.touched.country &&
                              formik.errors.country &&
                              "democlass"
                            }
                            styles={{
                              border:
                                formik.touched.country && formik.errors.country
                                  ? "1px solid red"
                                  : "1px solid #ccc",
                            }}
                          />
                          {formik.touched.country && formik.errors.country && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.country}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col lg={4} md={4} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          State
                        </FormLabel>

                        <Select
                          name="state"
                          options={State?.getStatesOfCountry(
                            selectedCountry?.isoCode
                          )}
                          placeholder="Select State"
                          getOptionLabel={(options) => {
                            return options["name"];
                          }}
                          getOptionValue={(options) => {
                            return options["name"];
                          }}
                          value={selectedState}
                          onChange={(item) => {
                            if (selectedState?.isoCode !== item.isoCode) {
                              setSelectedState(item);
                              setSelectedCity(null);
                              setParsedata({
                                ...parsedata,
                                state: item.name,
                              });
                              formik.setFieldValue("state", item.name);
                              formik.setFieldValue("city", "");
                            }
                          }}
                          classNamePrefix={
                            formik.touched.state &&
                            formik.errors.state &&
                            "democlass"
                          }
                          styles={{
                            border:
                              formik.touched.state && formik.errors.state
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.state && formik.errors.state ? (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.state}
                          </div>
                        ) : null}
                      </Col>
                      <Col lg={4} md={4} style={{ marginBottom: "24px" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          City
                        </FormLabel>
                        <Select
                          name="city"
                          options={City.getCitiesOfState(
                            selectedState?.countryCode,
                            selectedState?.isoCode
                          )}
                          placeholder="Select City"
                          getOptionLabel={(options) => {
                            return options["name"];
                          }}
                          getOptionValue={(options) => {
                            return options["name"];
                          }}
                          value={selectedCity}
                          onChange={(item) => {
                            setSelectedCity(item);
                            formik.setFieldValue("city", item.name);
                            setParsedata({
                              ...parsedata,
                              city: item.name,
                            });
                          }}
                          classNamePrefix={
                            formik.touched.city &&
                            formik.errors.city &&
                            "democlass"
                          }
                          styles={{
                            border:
                              formik.touched.city && formik.errors.city
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />

                        {formik.touched.city && formik.errors.city && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.city}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Skill
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Skill"
                          size="lg"
                          name="skill"
                          value={formik.values.skill}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              city: e.target.value,
                            });
                          }}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.skill && formik.errors.skill
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.skill && formik.errors.skill && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.skill}
                          </div>
                        )}
                      </Col>
                      <Col lg={3} md={3} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Experience (in years)
                        </FormLabel>
                        <Input
                          className="form-control"
                          name="experiance"
                          type="number"
                          min="0"
                          max="100"
                          step="0.1"
                          placeholder="Experience"
                          value={formik.values.experiance}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.experiance &&
                                formik.errors.experiance
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        ></Input>
                        {formik.touched.experiance &&
                          formik.errors.experiance && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.experiance}
                            </div>
                          )}
                      </Col>
                      <Col lg={3} md={3}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Industry
                        </FormLabel>
                        <select
                          className="form-control"
                          name="industry"
                          value={formik.values.industry}
                          onChange={formik.handleChange}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.industry && formik.errors.industry
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        >
                          <option disabled={true} value="">
                            Select Industry
                          </option>
                          {industries?.map((val) => (
                            <>
                              <option value={val?.industry}>
                                {val?.industry}
                              </option>
                            </>
                          ))}
                        </select>
                        {formik.touched.industry && formik.errors.industry && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.industry}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={6} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Date Of Birth
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="date"
                          placeholder="Date Of Birth"
                          size="lg"
                          name="dateofBirth"
                          value={formik.values.dateofBirth}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{ width: "100%", height: "37px" }}
                        />
                      </Col>
                      <Col lg={4} md={6} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Gender
                        </FormLabel>
                        <select
                          className="form-control"
                          name="gender"
                          value={formik.values.gender}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.gender && formik.errors.gender
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        >
                          <option disabled value={""}>
                            Select
                          </option>
                          <option>Male</option>
                          <option>Female</option>
                          <option>Other</option>
                        </select>
                        {formik.touched.gender && formik.errors.gender && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.gender}
                          </div>
                        )}
                      </Col>
                      <Col lg={4} md={6} style={{ marginBottom: "2rem" }}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Notice period (in days)
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="number"
                          placeholder="Notice Period"
                          size="lg"
                          name="noticePeriod"
                          id="noticePeriod"
                          value={formik.values.noticePeriod}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.noticePeriod &&
                                formik.errors.noticePeriod
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        />
                        {formik.touched.noticePeriod &&
                          formik.errors.noticePeriod && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                              {formik.errors.noticePeriod}
                            </div>
                          )}
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Current Candidate CTC"
                            name="currentCandidateCTC"
                            value={formik.values.currentCandidateCTC}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{
                              height: "37px",
                            }}
                          />
                          <div>
                            <select
                              className="form-control"
                              name="currentCandidateCTCType"
                              value={formik.values.currentCandidateCTCType}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              style={{
                                height: "37px",
                                fontSize: "14px",
                                width: "auto",
                              }}
                            >
                              <option disabled={true} value="">
                                Select
                              </option>
                              <option>Monthly</option>
                              <option>Annual Salary</option>
                              <option>Other</option>
                            </select>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6} md={6} style={{ marginBottom: "2rem" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Expected Candidate CTC"
                            name="expectedCandidateCTC"
                            value={formik.values.expectedCandidateCTC}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{
                              height: "37px",
                            }}
                          />
                          <select
                            className="form-control"
                            name="expectedCandidateCTCType"
                            value={formik.values.expectedCandidateCTCType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{
                              height: "37px",
                              fontSize: "14px",
                              width: "auto",
                            }}
                          >
                            <option disabled={true} value="">
                              Select
                            </option>
                            <option>Monthly</option>
                            <option>Annual Salary</option>
                            <option>Other</option>
                          </select>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Aadhar Card Number
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Aadhar Card Number"
                          mb="24px"
                          size="lg"
                          name="AadharcardNumber"
                          value={formik.values.AadharcardNumber}
                          onChange={formik.handleChange}
                          style={{ width: "100%", height: "37px" }}
                        />
                      </Col>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          PAN Card Number
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="tel"
                          placeholder="PAN Card Number"
                          mb="24px"
                          size="lg"
                          name="PancardNumber"
                          value={formik.values.PancardNumber}
                          onChange={formik.handleChange}
                          style={{ width: "100%", height: "37px" }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Address
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Address"
                          mb="24px"
                          size="lg"
                          name="address"
                          value={formik.values.address}
                          onChange={(e) => {
                            formik.handleChange(e);
                            setParsedata({
                              ...parsedata,
                              address: e.target.value,
                            });
                          }}
                          style={{ width: "100%", height: "37px" }}
                        />
                      </Col>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Pincode
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Pincode"
                          mb="24px"
                          size="lg"
                          name="pincode"
                          value={formik.values.pincode}
                          onChange={formik.handleChange}
                          style={{ width: "100%", height: "37px" }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Source
                        </FormLabel>
                        <select
                          className="form-control"
                          name="source"
                          value={formik.values.source}
                          onChange={formik.handleChange}
                          style={{
                            width: "100%",
                            height: "37px",
                            border:
                              formik.touched.source && formik.errors.source
                                ? "1px solid red"
                                : "1px solid #ccc",
                          }}
                        >
                          <option disabled={true} value="">
                            Select
                          </option>
                          {sourceData.map((source, index) => {
                            return (
                              <option key={index}>{source?.source}</option>
                            );
                          })}
                        </select>
                        {formik.touched.source && formik.errors.source && (
                          <div style={{ color: "red", fontSize: "14px" }}>
                            {formik.errors.source}
                          </div>
                        )}
                      </Col>
                      <Col lg={6} md={6}>
                        <FormLabel
                          ms="4px"
                          fontSize="sm"
                          fontWeight="400"
                          fontFamily="Roboto"
                          color="#000000"
                        >
                          Candidate Status
                        </FormLabel>
                        <Input
                          variant="auth"
                          fontSize="sm"
                          ms="4px"
                          type="text"
                          placeholder="Pincode"
                          mb="24px"
                          size="lg"
                          name="candidateStatus"
                          value={formik.values.candidateStatus}
                          style={{ width: "100%", height: "37px" }}
                        />
                        {/* <select
                          className="form-control"
                          name="candidateStatus"
                          value={formik.values.candidateStatus}
                          onChange={formik.handleChange}
                          style={{ width: "100%", height: "37px" }}
                        >
                          <option disabled={true} value="">
                            Candidate Status
                          </option>
                          {candidateStatus?.map((val) => (
                            <>
                              <option value={val?.candidateStatus}>
                                {val?.candidateStatus}
                              </option>
                            </>
                          ))}
                        </select> */}
                      </Col>
                    </Row>
                  </Container>
                  <br />
                  {/* For Education Details */}
                  <Container>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.3rem",
                          padding: "0.3rem",
                          paddingBottom: "15px",
                        }}
                        className="usertitle"
                      >
                        Education Details
                      </h1>
                      <span
                        style={{
                          display: "flex",
                          width: "76px",
                          height: "34px",
                          fontFamily: "Roboto",
                          color: "#627D8C",
                          fontSize: "20px",
                          border: "1.2px solid #87A6B7",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "3px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleAddEducation();
                        }}
                      >
                        Add
                      </span>
                    </div>
                    {eductionFields.map((education, index) => {
                      return (
                        <div key={index} style={{ position: "relative" }}>
                          <div className="close_icon">
                            <CloseButton
                              onClick={() => {
                                let filterData = eductionFields.filter(
                                  (res, In) => In !== index
                                );
                                setEductionFields(filterData);
                              }}
                            />
                          </div>
                          <div
                            style={{
                              border: "1px solid #d3d1d1",
                              width: "100%",
                              height: "auto",
                              borderRadius: "5px",
                              padding: "10px",
                            }}
                          >
                            <Container>
                              <form>
                                <Row>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Institute Name
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Institute Name"
                                      mb="24px"
                                      size="lg"
                                      name="institutename"
                                      value={
                                        education?.institutename
                                          ? education?.institutename
                                          : ""
                                      }
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Degree
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Degree"
                                      mb="24px"
                                      size="lg"
                                      name="degree"
                                      value={
                                        education?.degree
                                          ? education?.degree
                                          : ""
                                      }
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col
                                    lg={4}
                                    md={4}
                                    style={{ marginBottom: "1rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Category
                                    </label>
                                    <select
                                      className="form-control"
                                      name="category"
                                      value={education.category}
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    >
                                      <option disabled={true} value="">
                                        Select
                                      </option>
                                      <option>High School</option>
                                      <option>Military Service</option>
                                      <option>Vocational School</option>
                                      <option>Associate</option>
                                      <option>Pre-Bachelors</option>
                                      <option>Bachelors</option>
                                      <option>Post-Bachelors</option>
                                      <option>Masters</option>
                                      <option>Doctorate</option>
                                      <option>Other</option>
                                    </select>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Passing Year
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="number"
                                      placeholder="Passing Year"
                                      mb="24px"
                                      size="lg"
                                      name="endDate"
                                      value={education.endDate}
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      CGPA/Percentage
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="CGPA/Percentage"
                                      mb="24px"
                                      size="lg"
                                      name="percentage"
                                      value={
                                        education?.percentage
                                          ? education?.percentage
                                          : ""
                                      }
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                </Row>
                              </form>
                            </Container>
                          </div>
                          <br />
                        </div>
                      );
                    })}
                  </Container>
                  {/* For Work Experience Details */}
                  <Container>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.3rem",
                          padding: "0.3rem",
                          paddingBottom: "15px",
                        }}
                        className="usertitle"
                      >
                        Work Experience Details
                      </h1>
                      <span
                        style={{
                          display: "flex",
                          width: "76px",
                          height: "34px",
                          fontFamily: "Roboto",
                          color: "#627D8C",
                          fontSize: "20px",
                          border: "1.2px solid #87A6B7",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "3px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleAddWork();
                        }}
                      >
                        Add
                      </span>
                    </div>
                    {workExperienceFields.map((work, index) => {
                      return (
                        <div key={index} style={{ position: "relative" }}>
                          <div className="close_icon">
                            <CloseButton
                              onClick={() => {
                                let filterData = workExperienceFields.filter(
                                  (res, In) => In !== index
                                );
                                setWorkexperienceFields(filterData);
                              }}
                            />
                          </div>
                          <div
                            style={{
                              border: "1px solid #d3d1d1",
                              width: "100%",
                              height: "auto",
                              borderRadius: "5px",
                              padding: "10px",
                            }}
                          >
                            <Container>
                              <form id="workExperienceFields">
                                <Row>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Company Name
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="companyname"
                                      mb="24px"
                                      size="lg"
                                      name="companyname"
                                      value={
                                        work?.companyname
                                          ? work?.companyname
                                          : ""
                                      }
                                      onChange={(event) =>
                                        handleFormWorkChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Designation
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Designation"
                                      mb="24px"
                                      size="lg"
                                      name="designation"
                                      value={
                                        work?.designation
                                          ? work?.designation
                                          : ""
                                      }
                                      onChange={(event) =>
                                        handleFormWorkChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Start Date
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="month"
                                      placeholder="Start Date"
                                      mb="24px"
                                      size="lg"
                                      name="startDate"
                                      value={work.startDate}
                                      onChange={(event) =>
                                        handleFormWorkChange(index, event)
                                      }
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      End Date
                                    </label>
                                    {work.endDate?.toLowerCase() == "present" ||
                                      work.endDate?.toLowerCase() == "ongoing" ||
                                      work.endDate?.toLowerCase() == "current" ? (
                                      <div>
                                        <Checkbox
                                          mt={1}
                                          defaultChecked
                                          // readOnly
                                          onChange={(e) => {
                                            if (!e.target.checked) {
                                              handleFormWorkChange(index, {
                                                target: {
                                                  name: "endDate",
                                                  value: new Date()
                                                    .toISOString()
                                                    .slice(0, 7),
                                                },
                                              });
                                            } else {
                                              handleFormWorkChange(index, {
                                                target: {
                                                  name: "endDate",
                                                  value: present,
                                                },
                                              });
                                            }
                                          }}
                                        >
                                          Present
                                        </Checkbox>
                                      </div>
                                    ) : (
                                      <Input
                                        variant="auth"
                                        fontSize="sm"
                                        type="month"
                                        placeholder="End Date"
                                        mb="24px"
                                        size="lg"
                                        name="endDate"
                                        value={work.endDate}
                                        onChange={(event) =>
                                          handleFormWorkChange(index, event)
                                        }
                                        style={{
                                          width: "100%",
                                          height: "37px",
                                        }}
                                      />
                                    )}
                                  </Col>
                                  <Col
                                    lg={4}
                                    md={4}
                                    style={{ marginBottom: "2rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Country
                                    </label>
                                    <Select
                                      name="country"
                                      options={Country.getAllCountries()}
                                      placeholder="Select Country"
                                      getOptionLabel={(options) => {
                                        return options["name"];
                                      }}
                                      getOptionValue={(options) => {
                                        return options["name"];
                                      }}
                                      value={
                                        work.country
                                          ? {
                                            name: work.country,
                                            isoCode: work.countryCode,
                                          }
                                          : null
                                      }
                                      onChange={(value, action) => {
                                        setSelectedWorkCountry(value);
                                        handleFormWorkExpChange(
                                          index,
                                          value,
                                          action
                                        );
                                      }}
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col
                                    lg={4}
                                    md={4}
                                    style={{ marginBottom: "2rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      State
                                    </label>
                                    <Select
                                      name="state"
                                      options={State.getStatesOfCountry(
                                        work.countryCode
                                      )}
                                      placeholder="Select State"
                                      getOptionLabel={(options) => {
                                        return options["name"];
                                      }}
                                      getOptionValue={(options) => {
                                        return options["name"];
                                      }}
                                      value={
                                        work.state
                                          ? {
                                            name: work.state,
                                            isoCode: work.stateCode,
                                          }
                                          : null
                                      }
                                      onChange={(value, action) => {
                                        handleFormWorkExpChange(
                                          index,
                                          value,
                                          action
                                        );
                                      }}
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col
                                    lg={4}
                                    md={4}
                                    style={{ marginBottom: "2rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      City
                                    </label>
                                    <Select
                                      name="city"
                                      options={City.getCitiesOfState(
                                        work.countryCode,
                                        work.stateCode
                                      )}
                                      placeholder="Select City"
                                      getOptionLabel={(options) => {
                                        return options["name"];
                                      }}
                                      getOptionValue={(options) => {
                                        return options["name"];
                                      }}
                                      value={
                                        work.city ? { name: work.city } : null
                                      }
                                      onChange={(value, action) => {
                                        handleFormWorkExpChange(
                                          index,
                                          value,
                                          action
                                        );
                                      }}
                                      style={{ width: "100%", height: "37px" }}
                                    />
                                  </Col>
                                  <Col></Col>
                                  <Col></Col>
                                  <Col lg={12} md={12}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Responsibilities
                                    </label>
                                    {(work?.responsibilities || []).map((res, resIndex) => (
                                      <div key={resIndex} style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                                        <Input
                                          variant="auth"
                                          fontSize="sm"
                                          type="text"
                                          placeholder="Enter responsibility"
                                          size="lg"
                                          value={res}
                                          onChange={(e) => {
                                            let data = [...workExperienceFields];
                                            let resps = [...(data[index].responsibilities || [])];
                                            resps[resIndex] = e.target.value;
                                            data[index].responsibilities = resps;
                                            setWorkexperienceFields(data);
                                          }}
                                          style={{ width: "100%", height: "37px" }}
                                        />
                                        <button
                                          type="button"
                                          onClick={() => {
                                            let data = [...workExperienceFields];
                                            let resps = [...(data[index].responsibilities || [])];
                                            resps.splice(resIndex, 1);
                                            data[index].responsibilities = resps;
                                            setWorkexperienceFields(data);
                                          }}
                                          style={{
                                            marginLeft: "8px",
                                            background: "red",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            padding: "4px 10px",
                                            cursor: "pointer",
                                            fontSize: "13px",
                                          }}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    ))}
                                    <button
                                      type="button"
                                      onClick={() => {
                                        let data = [...workExperienceFields];
                                        data[index].responsibilities = [...(data[index].responsibilities || []), ""];
                                        setWorkexperienceFields(data);
                                      }}
                                      style={{
                                        background: "#083c64",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "6px 14px",
                                        cursor: "pointer",
                                        fontSize: "13px",
                                        marginTop: "4px",
                                      }}
                                    >
                                      + Add Responsibility
                                    </button>
                                  </Col>
                                </Row>
                              </form>
                            </Container>
                          </div>
                          <br />
                        </div>
                      );
                    })}
                  </Container>
                  {/* For Reference Details */}
                  <Container>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.3rem",
                          padding: "0.3rem",
                          paddingBottom: "15px",
                        }}
                        className="usertitle"
                      >
                        Reference Details
                      </h1>
                      <span
                        style={{
                          display: "flex",
                          width: "76px",
                          height: "34px",
                          fontFamily: "Roboto",
                          color: "#627D8C",
                          fontSize: "20px",
                          border: "1.2px solid #87A6B7",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "3px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleAddReference();
                        }}
                      >
                        Add
                      </span>
                    </div>
                    {referenceFields.map((reference, index) => {
                      return (
                        <div key={index} style={{ position: "relative" }}>
                          <div className="close_icon">
                            <CloseButton
                              onClick={() => {
                                let filterData = referenceFields.filter(
                                  (res, In) => In !== index
                                );
                                setReferenceFields(filterData);
                              }}
                            />
                          </div>
                          <div
                            style={{
                              border: "1px solid #d3d1d1",
                              width: "100%",
                              height: "auto",
                              borderRadius: "5px",
                              padding: "10px",
                              marginBottom: "1.3rem",
                            }}
                          >
                            <Container>
                              <form>
                                <Row>
                                  <Col
                                    lg={4}
                                    md={4}
                                    style={{ marginBottom: "2rem" }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Reference Type
                                    </label>
                                    <select
                                      className="form-control"
                                      name="referenceType"
                                      value={reference.referenceType}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{
                                        height: "37px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <option disabled={true} value="">
                                        Select
                                      </option>
                                      <option>Other</option>
                                      <option>Personal</option>
                                      <option>Professional</option>
                                    </select>
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Reference Name
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Reference Name"
                                      mb="24px"
                                      size="lg"
                                      name="referenceName"
                                      value={reference.referenceName}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{ height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Company Name
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Company Name"
                                      mb="24px"
                                      size="lg"
                                      name="companyName"
                                      value={reference.companyName}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{ height: "37px" }}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Designation
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Designation"
                                      mb="24px"
                                      size="lg"
                                      name="designation"
                                      value={reference.designation}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{ height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Email
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Email"
                                      mb="24px"
                                      size="lg"
                                      name="email"
                                      value={reference.email}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{ height: "37px" }}
                                    />
                                  </Col>
                                  <Col lg={4} md={4}>
                                    <label
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: "400",
                                        fontFamily: "Roboto",
                                        color: "#000000",
                                      }}
                                    >
                                      Phone
                                    </label>
                                    <Input
                                      variant="auth"
                                      fontSize="sm"
                                      type="text"
                                      placeholder="Phone"
                                      mb="24px"
                                      size="lg"
                                      name="phone"
                                      value={reference.phone}
                                      onChange={(event) =>
                                        handleFormReferenceChange(index, event)
                                      }
                                      style={{ height: "37px" }}
                                    />
                                  </Col>
                                </Row>
                              </form>
                            </Container>
                          </div>
                        </div>
                      );
                    })}
                  </Container>
                  <Container>
                    <Box display="flex" justifyContent="end" mt={5} mb={5}>
                      <Checkbox
                        isChecked={sendMail}
                        onChange={() => setSendMail(!sendMail)}
                      >
                        <span style={{ fontSize: "14px" }}>
                          You Want to send mail to Candidate
                        </span>
                      </Checkbox>
                    </Box>
                    {parseSummary && <Box mb={1}>{parseSummary}</Box>}
                    {parsedObjectives && (
                      <Box mt={1}>
                        <h1
                          style={{
                            fontWeight: "bold",
                            fontSize: "1.3rem",
                            padding: "0.3rem",
                            paddingBottom: "5px",
                          }}
                          className="usertitle"
                        >
                          Objectives
                        </h1>
                        <ul style={{ padding: "0.5rem" }}>
                          {parsedata?.objectives?.map((res) => {
                            return <li key={res}>{res}</li>;
                          })}
                        </ul>
                      </Box>
                    )}
                  </Container>
                  <Modal.Footer
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      className="cancel"
                      type="button"
                      onClick={handleCandidateClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      w={"100px"}
                      className="bg_color"
                      color={"#fff"}
                      type="submit"
                      isLoading={candidateLoading}
                    >
                      Save
                    </Button>
                  </Modal.Footer>
                </form>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Modal for Edit Candidate */}
        <EditCandidateModal
          ViewEdit={ViewEdit}
          handleEditClose={handleEditClose}
          editFormik={editFormik}
          saveFile={saveFile}
          parseSummary={parseSummary}
          resumeFilePath={resumeFilePath}
          toggleResumeDetails={toggleResumeDetails}
          showResumeDetails={showResumeDetails}
          setParsedata={setParsedata}
          Country={Country}
          setSelectedCountry={setSelectedCountry}
          setCandidate={setCandidate}
          applicationStatus={applicationStatus}
          sourceData={sourceData}
          candidateStatus={candidateStatus}
          handleAddEducation={handleAddEducation}
          eductionFields={eductionFields}
          setEductionFields={setEductionFields}
          handleFormChange={handleFormChange}
          handleAddWork={handleAddWork}
          workExperienceFields={workExperienceFields}
          setWorkexperienceFields={setWorkexperienceFields}
          handleFormWorkChange={handleFormWorkChange}
          setSelectedWorkCountry={setSelectedWorkCountry}
          handleFormWorkExpChange={handleFormWorkExpChange}
          setSelectedWorkState={setSelectedWorkState}
          setSelectedorkCity={setSelectedorkCity}
          handleAddReference={handleAddReference}
          referenceFields={referenceFields}
          setReferenceFields={setReferenceFields}
          handleFormReferenceChange={handleFormReferenceChange}
          setSendMail={setSendMail}
          sendMail={sendMail}
          handleDelete={handleDelete}
          selectedCountry={selectedCountry}
          selectedWorkCountry={selectedWorkCountry}
          selectedWorkState={selectedWorkState}
          selectedWorkCity={selectedWorkCity}
          candidateLoading={candidateLoading}
          file={file}
          parsedata={parsedata}
          candidate={candidate}
          setSelectedCity={setSelectedCity}
          selectedCity={selectedCity}
          setSelectedState={setSelectedState}
          selectedState={selectedState}
          industries={industries}
          parsedObjectives={parsedObjectives}
        />

        {/* Modal for Parse Documnet*/}
        <div className="model-box-view">
          <Modal
            show={ViewparseModel}
            onHide={handleViewparseClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title className="usertitle">Parse Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box style={{ textAlign: "center" }}>
                <Box>
                  <ErrorOutlineOutlinedIcon
                    style={{ fontSize: "3rem", color: "#f39c12" }}
                  />
                </Box>
                <Text style={{ fontSize: "19px" }}>Are You Sure?</Text>
                <div
                  class="custom-loader"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "auto",
                    display: "none",
                  }}
                  id="parse_loader"
                ></div>
                <Text
                  style={{ fontSize: "small", color: "grey" }}
                  id="parse_text"
                >
                  Do you want to parse this document ?
                </Text>
              </Box>
            </Modal.Body>
            <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
              <Button className="cancel" onClick={handleViewparseClose}>
                NO
              </Button>
              <Button
                w={"100px"}
                className="bg_color"
                color={"#fff"}
                onClick={handleParseSubmit}
                id="resume_parse"
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* Modal for Duplicate Resume*/}
        <div className="model-box-view">
          <Modal
            show={resumeDuplicateModel}
            onHide={handleResumeDuplicateClose}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title className="usertitle">Duplicate Resume</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box>
                <Text
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    gap: "8px",
                    marginBottom: "1rem",
                  }}
                >
                  <WarningIcon style={{ color: "red", fontSize: "20px" }} />{" "}
                  Candidate already exists with this email.
                </Text>
                <Text>
                  Candidate Name :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {findCandidate?.firstName
                      ? findCandidate?.firstName
                      : "N/A"}{" "}
                    {findCandidate?.lastName ? findCandidate?.lastName : "N/A"}
                  </span>
                </Text>
                <Text>
                  Created Date :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {!findCandidate?.created_at
                      ? "N/A"
                      : typeof findCandidate?.created_at === "string"
                        ? findCandidate?.created_at
                        : new Date(
                          findCandidate?.created_at
                        ).toLocaleDateString("en-GB")}
                  </span>
                </Text>
                <Text>
                  Candidate Owner :{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {!findCandidate?.candidate_ownerName
                      ? "N/A"
                      : findCandidate?.candidate_ownerName}
                  </span>
                </Text>
                <RadioGroup
                  style={{ marginLeft: "2rem", marginTop: "0.5rem" }}
                  onChange={setRadioValue}
                  value={radiovalue}
                  defaultValue="Add Resume and Update candidate profile"
                >
                  <Stack direction="column">
                    <Radio value="Add Resume">Add Resume</Radio>
                    <Radio value="Add Resume and Update candidate profile">
                      Add Resume and Update candidate profile
                    </Radio>
                    <Radio value="Do not replace the profile">
                      Do not replace the profile
                    </Radio>
                  </Stack>
                </RadioGroup>
              </Box>
            </Modal.Body>
            <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
              <Button className="cancel" onClick={handleResumeDuplicateClose}>
                Cancel
              </Button>
              <Button
                isLoading={loading}
                w={"100px"}
                className="bg_color"
                color={"#fff"}
                id="resume_parse"
                onClick={() => {
                  handleProceed(radiovalue);
                }}
              >
                Proceed
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Box>
      {loading ? <div className="loader_import"></div> : null}
    </Box>
  );
}

export default Jobpostview;
